import { Component, Fragment, useState, useRef, useEffect, useCallback, useMemo } from 'react';
import Link from '@/components/zone-link';
import Head from 'next/head';
import Image from 'next/image';
import Router, { useRouter } from 'next/router';
import Layout from "@/components/event-layout";
import { Tooltip } from '@mui/material';
import PhoneInput from "@/components/phone-input";
import * as fbq from "@/lib/fbq";
import * as gtag from "@/lib/gtag";
import { FaqContent } from './information';
import { DateTime } from 'luxon';
import axios from 'axios';
import cookie from 'js-cookie';
import styles from './reserved_seating.module.css';
import { useGlobalKeyDown, getContrast, getHoldToken, clearHoldToken, RichResultsOutput, addAffiliateCookie, CurrencySymbol } from "@/lib/site";
import { BrandedLoading } from './index';
import { CalendarToday, LocationCity, InfoOutlined, EmailOutlined, ShoppingCartOutlined, Add, Remove, Refresh, KeyboardArrowUp, KeyboardArrowDown, KeyboardArrowRight, KeyboardArrowLeft, Close, Sync, Accessible, AddOutlined, RemoveOutlined, WarningOutlined, ScheduleOutlined, EventNoteOutlined, LocationOnOutlined, TodayOutlined, LockOutlined, Tune, HelpOutline, ExpandMore } from '@mui/icons-material';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { ToastContainer, toast } from 'react-toastify';

// translation content
import enAU from "@/locales/en-AU/common.json";
import enUS from "@/locales/en-US/common.json";

export default function ReservedSeating({ event={"utc_event_finish_date":undefined}, org={"logo_image":undefined,"background_color":"000000"}, stripe_account, venue, tracking_pixels=[], faqs, long_description }){
	const [displayGaTooltip, setDisplayGaTooltip] = useState(false);
	const [displayGaTooltipHover, setDisplayGaTooltipHover] = useState(undefined);
	const [displayGaSectionId, setDisplayGaSectionId] = useState(undefined);
	const [loadingMap, setLoadingMap] = useState(true);
	const [loadingList, setLoadingList] = useState(true);
	const [ticketsAvailableMap, setTicketsAvailableMap] = useState([]);
	const [ticketsAvailableList, setTicketsAvailableList] = useState([]);
	const [mapSections, setMapSections] = useState([]);
	const [units, setUnits] = useState(2);
	const [mapSizeHeight, setMapSizeHeight] = useState(1000);
	const [mapSizeWidth, setMapSizeWidth] = useState(1000);
	const [mapBackgroundImage, setMapBackgroundImage] = useState('');
	const [mapFocalPoint, setMapFocalPoint] = useState(null);
	const [tooltipData, setTooltipData] = useState(undefined);
	const [loadingSeatInfo, setLoadingSeatInfo] = useState(true);
	const [selected, setSelected] = useState([]);
	const [selectedHeight, setSelectedHeight] = useState(100);
	const [cart, setCart] = useState([]);
	const [addToCartLoading, setAddToCartLoading] = useState(false);
	const [addToCartError, setAddToCartError] = useState(false);
	const [displayTicketLimitModal, setDisplayTicketLimitModal] = useState(false);
	const [selectedEventSectionId, setSelectedEventSectionId] = useState(0);
	const [displayAccessibleModal, setDisplayAccessibleModal] = useState(false);
	const [accessibleModalAgree, setAccessibleModalAgree] = useState(false);
	const [displayFilter, setDisplayFilter] = useState(false);
	const [ticketTypesFilter, setTicketTypesFilter] = useState([]);
	const [accessibleFilter, setAccessibleFilter] = useState(false);
	const [membership, setMembership] = useState({"url_string":""});
	const [categories, setCategories] = useState([]);
	const [membershipCategories, setMembershipCategories] = useState([]);
	const [loadingCategories, setLoadingCategories] = useState(true);
	const [unlockModal, setUnlockModal] = useState(false);
	const [unlockCode, setUnlockCode] = useState('');
	const [unlockCodeError, setUnlockCodeError] = useState(undefined);
	const [unlockedArray, setUnlockedArray] = useState([]);
	const [submitError, setSubmitError] = useState(undefined);
	const [validateFinish, setValidateFinish] = useState(false);
	const [displaySoldOutModal, setDisplaySoldOutModal] = useState(false);
	const [specialInstructionsLoading, setSpecialInstructionsLoading] = useState(true);
	const [specialInstructions, setSpecialInstructions] = useState(undefined);
	const [windowWidth, setWindowWidth] = useState(1024);
	const [orphanSeatWarning, setOrphanSeatWarning] = useState(undefined);
	const [displayOrphanSeatWarningModal, setDisplayOrphanSeatWarningModal] = useState(false);
	const [displayPriceNotSelectedModal, setDisplayPriceNotSelectedModal] = useState(false);
	const [urlUnlockPromotion, setUrlUnlockPromotion] = useState(undefined);
	const [pageUrl, setPageUrl] = useState('');
	const [priceCategoryList, setPriceCategoryList] = useState([]);
	const [metaDescription, setMetaDescription] = useState('');
	const [displayInfoModal, setDisplayInfoModal] = useState(false);
	const [displayContactModal, setDisplayContactModal] = useState(false);
	const [helpModalDisplay, setHelpModalDisplay] = useState(false);
	const [rightListHover, setRightListHover] = useState(undefined);
	const [rightListHoverPosition, setRightListHoverPosition] = useState({x:0,y:0});
	const [companionRules, setCompanionRules] = useState([]);
	const [loadingCompanionRules, setLoadingCompanionRules] = useState(true);

	const router = useRouter();
	const { locale } = router;
	const t = locale == "en-AU" ? enAU : locale == "en-US" ? enUS : enAU;
	const handleResize = () => { setWindowWidth(window.innerWidth); };
	const svgRef = useRef(null);

	useGlobalKeyDown( e => {
		if( unlockModal === true ){
			if (e.keyCode === 13){
				validateOfferCode(unlockCode);
			}
			if (e.keyCode === 27){
				setUnlockCode('');
				setUnlockCodeError(undefined);
				setUnlockModal(false);
			}
		}
	});

	useEffect(() => {
		if( Math.round((new Date()).getTime() / 1000) < event.utc_booking_finish_date ){
			fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/seat_map_info', { method: 'GET', headers: { 'Content-Type': 'application/json' } }).then(response => { if(response.ok){ return response.json(); } throw new Error('fetch error - /seat_map_info'); }).then(data => { if(data.error){ } else { setMapSizeHeight(data.height); setMapSizeWidth(data.width); setMapBackgroundImage(data.background_image); setMapFocalPoint(data.focal_point); } }).catch(error => { console.log(error); });
			document.getElementsByTagName("body")[0].style.cssText = "overflow:hidden;";
			loadCategories();
			loadCompanionRules();
		} else {
			setLoadingMap(false);
			setLoadingList(false);
		}
	}, []);

	useEffect(() => { if( router.isReady ){ if( router.query.price_category_id != undefined ){ setPriceCategoryList(router.query.price_category_id.split(',').map( Number )); } } }, [router.isReady]);
	useEffect(() => { if( router.query.affiliate_code != undefined ){ addAffiliateCookie( event.event_id, router.query.affiliate_code ); } }, [router.isReady]);
	useEffect(() => { if( router.query.promotion_code != undefined ){ setUrlUnlockPromotion( router.query.promotion_code ) }; }, [router.isReady]);
	useEffect(() => { if (router.isReady && router.query.token != undefined ){ const get_token = cookie.get("token"); if( get_token === undefined ){ cookie.set("token", router.query.token, { expires: 0.99, sameSite: 'none', secure: true, path: '/' }); } } }, [router.isReady]);
	useEffect(() => { 
		if( event.sold_out === 1 ){ setDisplaySoldOutModal(true); } 
		setPageUrl("https://" + window.location.hostname + window.location.pathname); 
		let timeoutId = null;
		const resizeListener = () => {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => { setWindowWidth(window.innerWidth); }, 150);
		};
		handleResize(); 
		window.addEventListener('resize', resizeListener); 
		return () => {
			window.removeEventListener('resize', resizeListener);
       		clearTimeout(timeoutId); 
		}
	}, []);
	useEffect(() => { if( router.query.unlock_code != undefined ){ validateOfferCode( router.query.unlock_code ) }; }, [router.isReady]);
	useEffect(() => { try { axios.get('https://d2jun3ty2bmcrf.cloudfront.net/event/' + event.event_id + '/special_instructions.txt').then(res => { setSpecialInstructions(res.data); setSpecialInstructionsLoading(false); }).catch((error) => { setSpecialInstructionsLoading(false); }); } catch(error) {  } }, []);
	useEffect(() => { setTicketTypesFilter(priceCategoryList); if( priceCategoryList.length > 0 ){ setDisplayFilter(true); } }, [priceCategoryList]);
	useEffect(() => { return () => { document.getElementsByTagName("body")[0].style.overflow = null; } }, []);
	useEffect(() => { 
		if( selected.length > 0 && typeof window !== 'undefined' && window.innerWidth > 767 ){ 
			setSelectedHeight( window.innerHeight - document.getElementById('orgHeader').offsetHeight - document.getElementById('eventHeader').offsetHeight - document.getElementById('selectedTicketsHeader').offsetHeight - document.getElementById('selectedTicketsAdditional').offsetHeight - document.getElementById('ticketBagTotal').offsetHeight ); 
		}
	}, [selected]);
	useEffect(() => { 
		for (let i = 0; i < mapSections.length; i++){ loadSeatsInSection(mapSections[i].event_section_id, mapSections[i].section_type, i); }
		if( event.membership_seat_map_id > 0 ){ 
			loadMembership(); 
			loadMembershipCategory(); 
		}
	}, [mapSections]);
	useEffect(() => { 
		if( event.allow_orphan_seats === 0 && selected.length > 0 ){
			setOrphanSeatWarning(undefined);
			const ordered_cart = selected.sort((a, b) => a.event_section_id - b.event_section_id || a.row - b.row || a.seat - b.seat);
			for( var x = 0; x < selected.length; x++ ){
				const filtered_row = ticketsAvailableMap.filter(a => a.esid == selected[x].event_section_id && a.r == selected[x].row);
				const seat_less_one_number = parseInt(selected[x].seat) - 1;
				if( filtered_row.some(a => a.s == seat_less_one_number && a.ess == 0 ) ){
					// yes it exists and is available but check cart if its in there?
					const cart_less_one = selected.find(c => c.event_section_id == selected[x].event_section_id && c.row == selected[x].row && c.seat == seat_less_one_number);
					if( cart_less_one === undefined ){
						const seat_next_less = filtered_row.find(a => a.s == seat_less_one_number && ( a.ess == 0 ) );
						const seat_less_two_numbers = parseInt(selected[x].seat) - 2;
						if( !filtered_row.some(a => a.s == seat_less_two_numbers ) ){
							// no seat two across therefore stop process of sale
							setOrphanSeatWarning(seat_next_less.uuid);
						} else {
							// seat exists check availability
							// check its not in cart
							const cart_less_two = selected.find(c => c.event_section_id == selected[x].event_section_id && c.row == selected[x].row && c.seat == seat_less_two_numbers);
							if( cart_less_two != undefined ){
								setOrphanSeatWarning(seat_next_less.uuid);
							} else {
								const second_across_seat = filtered_row.find(a => a.s == seat_less_two_numbers );
								if( second_across_seat.ess != 0 ){ setOrphanSeatWarning(seat_next_less.uuid); }
							}
						}
					}
				}
				const seat_plus_one_number = parseInt(selected[x].seat) + 1;
				if( filtered_row.some(a => a.s == seat_plus_one_number && a.ess == 0 ) ){
					// yes it exists and is available but check cart if its in there?
					const cart_plus_one = selected.find(c => c.event_section_id == selected[x].event_section_id && c.row == selected[x].row && c.seat == seat_plus_one_number);
					if( cart_plus_one === undefined ){
						const seat_next_plus = filtered_row.find(a => a.s == seat_plus_one_number && ( a.ess == 0 ) );
						const seat_plus_two_numbers = parseInt(selected[x].seat) + 2;
						if( !filtered_row.some(a => a.s == seat_plus_two_numbers ) ){
							// no seat two across therefore stop process of sale
							setOrphanSeatWarning(seat_next_plus.uuid);
						} else {
							// seat exists check availability
							// check its not in cart
							const cart_plus_two = selected.find(c => c.event_section_id == selected[x].event_section_id && c.row == selected[x].row && c.seat == seat_plus_two_numbers);
							if( cart_plus_two != undefined ){
								setOrphanSeatWarning(seat_next_plus.uuid);
							} else {
								const second_across_seat = filtered_row.find(a => a.s == seat_plus_two_numbers );
								if( second_across_seat.ess != 0 ){ setOrphanSeatWarning(seat_next_plus.uuid); }
							}
						}
					}
				}
			}
		}
	}, [selected]);

	useEffect(() => { 
		if (!rightListHover || rightListHover.posX === undefined || rightListHover.posY === undefined){ return; }
		const svg = svgRef.current;
		if (svg){
			const point = svg.createSVGPoint();
			point.x = Number(rightListHover.posX);
			point.y = Number(rightListHover.posY);
			const ctm = svg.getScreenCTM();
			if (ctm) {
				const screenPos = point.matrixTransform(ctm);
				setRightListHoverPosition({ x: screenPos.x, y: screenPos.y });
			}
		}
	}, [rightListHover]);


	function updateTicketsMap(){
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/sections' , { method: 'GET', headers: { 'Content-Type': 'application/json' } })
		.then(response => { if(response.ok){ return response.json(); } throw new Error('fetch error - /sections'); })
		.then(data => { if(data.error){ } else { setMapSections(data); } })
		.catch(error => { console.log(error); })
	};

	function loadSeatsInSection( the_section_id, section_type, index ){
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/sections/' + the_section_id + '/seats', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
		.then(response => { if(response.ok){ return response.json(); } throw new Error('fetch error - /map'); })
		.then(data => { if(data.error){ } else { setTicketsAvailableMap(ticketsAvailableMap => [...ticketsAvailableMap, ...data]); } })
		.catch(error => { console.log(error); })
		.finally(() => { if( mapSections.length === ( index + 1 ) ){ setLoadingMap(false); } });
	}

	function updateTicketsList(){
		setLoadingList(true);
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/tickets?units=' + units, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
		.then(response => { if(response.ok){ return response.json(); } throw new Error('fetch error - /tickets?units='); })
		.then(data => { if(data.error){ } else { setTicketsAvailableList(data); } })
		.catch(error => { console.log(error); })
		.finally(() => { setLoadingList(false); });
	};

	function seatAddToCart(event_seat_uuid, section, row, seat, price_category_id, accessible_seating, restricted_view, event_section_id){
		setSelected(prevSelected => {
			if (prevSelected.length >= event.ticket_limit){
				setDisplayTicketLimitModal(true);
				return prevSelected;
			}
			if (prevSelected.some(s => s.event_seat_uuid === event_seat_uuid)) {
				return prevSelected;
			}
			return [ ...prevSelected, { "event_seat_uuid": event_seat_uuid, "section": section, "row": row, "seat": seat, "price_category_id": price_category_id, "price_id": 0, "accessible_seating": accessible_seating, "restricted_view": restricted_view, "event_section_id": event_section_id } ];
		});
		setTicketsAvailableMap(prevMap =>  prevMap.map((t) => { if (event_seat_uuid === t.uuid){ return { ...t, isSelect: true }; } return t; }) );
		setTooltipData(undefined);
		if (accessible_seating === 1 && accessibleModalAgree === false){ setDisplayAccessibleModal(true); }
		if( tracking_pixels.some(e => e.type === 'facebook') ){ fbq.event('AddToCart',{}); }
		if( tracking_pixels.some(e => e.type === 'google_tag') || tracking_pixels.some(e => e.type === 'google_analytics') ){ gtag.event('add_to_cart',{id: event_seat_uuid, category: price_category_id, quantity: 1 }); }
		if( tracking_pixels.some(e => e.type === 'tiktok') ){ window.ttq.track('AddToCart',{ content_id: event_seat_uuid, quantity: 1, currency: event.currency}); }
	};

	function seatInfo(event_seat_uuid, section, row, seat, price_category_id, accessible_seating, restricted_view, event_seat_status, seat_x, seat_y){
		const reference = document.querySelector('#s-' + event_seat_uuid);
		const svg = svgRef.current;
		if (svg){
			const point = svg.createSVGPoint();
			point.x = Number(seat_x);
			point.y = Number(seat_y);
			const ctm = svg.getScreenCTM();
			if(ctm){
				const screenPos = point.matrixTransform(ctm);
				const isTooCloseToTop = screenPos.y < 90;
				setTooltipData({ section: section, row: row, seat: seat, event_seat_status: event_seat_status, price_category_id: price_category_id, restricted_view: restricted_view, x: screenPos.x, y: screenPos.y, placement: isTooCloseToTop ? "bottom" : "top" });
			}
		}
	};

	function gaInfo(event_section_id,label,price_category_id,x,y){
		const svg = svgRef.current;
		if (svg){
			const point = svg.createSVGPoint();
			point.x = Number(x);
			point.y = Number(y);
			const ctm = svg.getScreenCTM();
			if(ctm){
				const screenPos = point.matrixTransform(ctm);
				const isTooCloseToTop = screenPos.y < 160;
				setDisplayGaTooltipHover({"event_section_id": event_section_id, "label": label, "price_category_id": price_category_id, x: screenPos.x, y: screenPos.y, placement: isTooCloseToTop ? "bottom" : "top"});
			}
		
		}
		setDisplayGaSectionId(event_section_id);
	}

	function validateReservedCartRules(currentCart) {
		let validCart = [...currentCart];
		if (!companionRules || companionRules.length === 0) return validCart;

		companionRules.forEach(rule => {
			const cartCounts = validCart.reduce((acc, seat) => {
				acc[seat.price_id] = (acc[seat.price_id] || 0) + 1;
				return acc;
			}, {});

			const timesTriggered = Math.min( ...rule.requirements.map(req => Math.floor((cartCounts[req.trigger_price_id] || 0) / req.trigger_quantity) ) );
			const maxAllowed = timesTriggered * rule.reward_quantity;
			const currentRewardCount = cartCounts[rule.reward_price_id] || 0;

			if (currentRewardCount > maxAllowed) {
				let excessToRevert = currentRewardCount - maxAllowed;
				for (let i = validCart.length - 1; i >= 0; i--) {
					if (validCart[i].price_id === rule.reward_price_id) {
						validCart[i] = { ...validCart[i], price_id: 0 }; 
						excessToRevert--;
						if (excessToRevert === 0) break; 
					}
				}
			}
		});
		return validCart;
	}

	function removeSelectedTicket(index, event_seat_uuid){
		setTicketsAvailableMap(prev => prev.map(s => 
			event_seat_uuid === s.uuid ? { ...s, isSelect: false } : s
		));
		const nextSelected = selected.filter(e => e.event_seat_uuid !== event_seat_uuid);
		setSelected(validateReservedCartRules(nextSelected));
	}

	function updatePriceIdOnSelected( event_seat_uuid, price_id ){ 
		setSelected(prev => {
			const updatedCart = prev.map(seat => event_seat_uuid === seat.event_seat_uuid ? { ...seat, price_id: price_id } : seat );
			return validateReservedCartRules(updatedCart);
		});
	}

	function addToCartLoadingSwitch(){ setAddToCartLoading(!addToCartLoading); }
	function handleUnitsChange(units_change){ setLoadingList(true); setUnits(units_change); updateTicketsList(); }
	function addToTicketTypeFilter(price_category_id){ setTicketTypesFilter([...ticketTypesFilter, price_category_id]); }
	function removeFromTicketTypeFilter(price_category_id){ const items = ticketTypesFilter.filter(item => item !== price_category_id); setTicketTypesFilter(items); }
	function groupArrayOfObjects(list, key){ return list.reduce(function(rv, x){ (rv[x[key]] = rv[x[key]] || []).push(x); return rv; }, {}); };
	function gaTicketsHide(){ setDisplayGaTooltip(false); }
	function switchToContactFormModal(){ setDisplayInfoModal(false); setDisplayContactModal(true); }

	async function submitSelected(){
		if( orphanSeatWarning != undefined ){ setDisplayOrphanSeatWarningModal(true); return; }
		if( selected.some(e => e.price_id === 0) ){ setDisplayPriceNotSelectedModal(true); return; }
		setValidateFinish(false);
		setAddToCartLoading(true);
		const groupedPrices = await groupArrayOfObjects(selected,"price_id");
		const keys = Object.getOwnPropertyNames(groupedPrices);
		try {
			for await (const item of keys){
				const validate = await fetch(process.env.NEXT_PUBLIC_API_URL +'/public/events/' + event.event_id + '/prices/' + item, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
				.then(response => response.json())
				.then(data => { if( data.tickets_included > 1 ){ if( data.tickets_included != groupedPrices[item].length){ setSubmitError('You must have ' + data.tickets_included + ' "' + data.title + '" tickets in your cart to proceed.' ); setAddToCartLoading(false); } } })
				.catch((error) => { setSubmitError('Oops! There was an error validating. Please try again after reloading the page'); setAddToCartLoading(false); });
			}
		} catch(err){
			setSubmitError('Oops! There was an error validating. Please reload the page and try again'); setAddToCartLoading(false);
		} finally {
			setValidateFinish(true);
		}
	}

	useEffect(() => { 
		if( submitError === undefined && validateFinish === true && orphanSeatWarning === undefined ){
			fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/add_reserved_seats', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Hold-Token': getHoldToken() }, body: JSON.stringify({ seats: selected, event_id: event.event_id, hold_token: getHoldToken() }) })
			.then(response => response.json())
			.then(data => { if(data.error){ setSubmitError(data.error.message); setAddToCartLoading(false); } else { setSelected([]); window.location.assign( '/checkout/?event_url=' + event.url_string + "&token=" + getHoldToken() + ( ( urlUnlockPromotion != undefined ) ? ( "&promotion_code=" + urlUnlockPromotion ) : '') ); fbq.event('InitiateCheckout',{}); gtag.event('begin_checkout',{}); } })
			.catch((error) => { setSubmitError(error); setAddToCartLoading(false); });
		}
	}, [validateFinish])

	function loadMembership(){
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/membership/org/' + event.org_id, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
		.then(response => response.json())
		.then(data => { if(data.error){ toast.error(data.error.message, { autoClose: 10000 }); } else { setMembership(data); } })
		.catch(error => { toast.error(error.message, { autoClose: 10000 }); });
	}

	function loadMembershipCategory(){
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/membership/' + event.org_id + '/category?membership_seat_map_id=' + event.membership_seat_map_id, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
		.then(response => response.json())
		.then(data => { if(data.error){ toast.error(data.error.message, { autoClose: 10000 }); } else { setMembershipCategories(data); } })
		.catch(error => { toast.error(error.message, { autoClose: 10000 }); });
	}

	function loadCategories(){
		setLoadingCategories(true);
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/price_category', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
		.then(response => response.json())
		.then(data => { if(data.error){ toast.error(data.error.message, { autoClose: 10000 }); } else { setCategories(data); } })
		.catch(error => { toast.error(error.message, { autoClose: 10000 }); })
		.finally(() => { setLoadingCategories(false); });
	}

	function loadCompanionRules() {
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/companion_ticketing', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
		.then(response => response.ok ? response.json() : Promise.reject('fetch error'))
		.then(data => { if (!data.error) setCompanionRules(data.data); updateTicketsMap(); })
		.catch(error => { console.log(error); })
		.finally(() => { setLoadingCompanionRules(false); });
	}

	function displayUnlockModal(){ setUnlockModal(true); }
	function validateOfferCode( unlock_code ){
		// don't submit if code is already in there
		if( unlockedArray.some(a => a.password.toLowerCase() == unlock_code.toLowerCase()) ){ setUnlockModal(false); return; }
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/general_admission/unlock', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ password: unlock_code }) })
		.then(response => response.json())
		.then(data => { if(data.error){ setUnlockCodeError(data.error.message) } else { setUnlockModal(false); setUnlockedArray([...unlockedArray, ...data.data]); setUnlockCode(''); } })
		.catch(error => { setUnlockCodeError(error); })
		.finally(() => { });
	}

	function sectionClick( seats_available, event_section_id, membership_seat_section_id ){
		if( membership_seat_section_id > 0 ){ window.open('https://am.intix.com/' + membership.url_string + '/' + ( membership.home_page_url_string ? membership.home_page_url_string : 'buy' ), '_blank'); return; }
		if( seats_available > 0 ){
			setSelectedEventSectionId( event_section_id ); 
			setDisplayGaTooltip(true);
			setDisplayGaTooltipHover(undefined);
		} else {
			// Do nothing
		}
	}										

	function sectionMouseEnter( seats_available, event_section_id, label, price_category_id, membership_seat_section_id, x, y ){
		if( membership_seat_section_id > 0 ){ return; }
		if( seats_available > 0 ){
			gaInfo( event_section_id, label, price_category_id, x, y );
		} else {
			// Do nothing
		}
	}

	return (
		<Layout title={event.enable_presale > 0 ? ("Subscribe - " + event.title) : event.event_type === 0 ? ("Buy " + event.title + " tickets") : ("Register for " + event.title)} logo={org.logo_image} theme={org.background_color} org_url_string={org.url_string} org_title={org.name} event_id={event.event_id} org_id={event.org_id} event_image={event.banner_image} event_id={event.event_id} meta_description={metaDescription} page_url={pageUrl} robots_meta={event.public_event === 1 && event.event_status_id === 1 ? 'all' : 'none' } favicon={org.favicon}>
			<Head>
				<link rel="alternate" href={"https://www.intix.com/event/" + event.url_string} hrefLang="x-default" />
				<link rel="alternate" href={"https://www.intix.com/event/" + event.url_string} hrefLang="en" />
				<link rel="alternate" href={"https://www.intix.com/event/" + event.url_string} hrefLang="en-us" />
				<link rel="alternate" href={"https://www.intix.com.au/event/" + event.url_string} hrefLang="en-au" />
				<link rel="alternate" href={"https://www.intix.co.uk/event/" + event.url_string} hrefLang="en-gb" />
				<link rel="alternate" href={"https://www.intix.co.nz/event/" + event.url_string} hrefLang="en-nz" />
				<link rel="alternate" href={"https://www.intix.ch/event/" + event.url_string} hrefLang="gsw" />
				{tracking_pixels.filter(e => e.type == 'facebook').map((item,index) => ( <script key={"facebook_pixel_" + index} id={"fb-pixel-" + index} dangerouslySetInnerHTML={{__html:`!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', ${item.pixel});` }} /> ))}
				{tracking_pixels.filter(e => e.type == 'google_analytics').map((item,index) => ( <Fragment key={"ga4-" + index}><script async src={"https://www.googletagmanager.com/gtag/js?id=" + item.pixel}></script><script key={"google_analytics_" + index} id={"google-tag-" + index} dangerouslySetInnerHTML={{__html:`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${item.pixel}');` }} /></Fragment> ))}
				{tracking_pixels.filter(e => e.type == 'google_tag').map((item,index) => ( <Fragment key={"gtm-" + index}><script async src={"https://www.googletagmanager.com/gtag/js?id=" + item.pixel}></script><script key={"google_tag_" + index} id={"gtm-" + index} dangerouslySetInnerHTML={{__html:`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${item.pixel}');` }} /></Fragment> ))}
				{tracking_pixels.filter(e => e.type == 'tiktok').map((item,index) => ( <script key={"tiktok_" + index} id={"tiktok-tag-" + index} dangerouslySetInnerHTML={{__html:`!function (w, d, t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};ttq.load('${item.pixel}');ttq.page();}(window, document, 'ttq');` }} /> ))}
			</Head>
			<div id="orgHeader" className={styles.headerUnfixed + " header"} style={{backgroundColor:'#' + org.background_color}}>
				<nav className="navbar navbar-default" role="navigation">
					<div className="navbar-header" style={{float:"left"}}>{ org.logo_image != null && org.logo_image.length > 0 ? ( <span className="navbar-brand" style={{marginLeft:"1.5rem"}}><img src={"https://d2jun3ty2bmcrf.cloudfront.net/org/" + org.url_string + "/" + org.logo_image} alt={org.name} /></span> ) : ( <a href="/" className="navbar-brand"><img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/logo-small-console.png" alt="INTIX" title="INTIX" /></a> )}</div>
					<div className="navbar-collapse" id="example-navbar-collapse" style={{height:"75px",display:"flex",justifyContent:"flex-end",alignItems:"center"}}>
						<button className={styles.mobileInfoButton} title="Event Info" onClick={e => setDisplayInfoModal(true)} style={{backgroundColor:"#" + org.background_color}}><InfoOutlined style={{fill:getContrast(org.background_color)}} alt="Info Icon" /></button>						
					</div>
				</nav>
			</div>
			<ToastContainer closeOnClick={true} draggable={false} autoClose={3500} closeButton={false} pauseOnHover={false} limit={3} hideProgressBar={true} pauseOnFocusLoss={false} theme="dark" />
			<div className={styles.ticketsDiv}>
				<HomeGameCalendar event_id={event.event_id} org_id={event.org_id} background_color={org.background_color} />
				<aside className={styles.mapContent}>
					{loadingMap === true || specialInstructionsLoading === true ? ( 
						<div className={styles.ticketsListLoading}><BrandedLoading logo_image={org.logo_image} background_color={org.background_color} url_string={org.url_string} /></div> 
					) : (
						<div id={"boundary"}>
							<div id={"popper-boundary"} tabIndex="-1" className={styles.zoomerArea}>
								<TransformWrapper centerOnInit={true} centerZoomedOut={true} wrapperClass={"boundary"} maxScale={15}>
									{({ zoomIn, zoomOut, resetTransform, instance }) => {
										const currentScale = instance.transformState.scale || 1;
										return (
											<Fragment>
												<div className={styles.zoomer_controls}>
													<button className={styles.hideOnMobile} title="Reset Zoom" onClick={e => resetTransform()} style={{backgroundColor:"#" + org.background_color}}><Refresh style={{fill:getContrast(org.background_color)}} /></button>
													<button title="Zoom In" onClick={e => zoomIn()} style={{backgroundColor:"#" + org.background_color}}><Add style={{fill:getContrast(org.background_color)}} /></button>
													<button title="Zoom Out" onClick={e => zoomOut()} style={{backgroundColor:"#" + org.background_color}}><Remove style={{fill:getContrast(org.background_color)}} /></button>
													<button className={styles.hideOnMobile} title="How to use this map" onClick={e => setHelpModalDisplay(true)} style={{backgroundColor:"#" + org.background_color}}><HelpOutline style={{fill:getContrast(org.background_color)}} /></button>
												</div>
												<TransformComponent wrapperClass="wrapperClass" contentClass="contentClass">
													<svg xmlns="http://www.w3.org/2000/svg" id="svg" ref={svgRef} className={styles.svg} viewBox={"0 0 " + mapSizeWidth + " " + mapSizeHeight} style={{backgroundImage:"url('https://d2jun3ty2bmcrf.cloudfront.net/event/" + event.event_id + "/seat_map_background/" + mapBackgroundImage + "')"}}>
														<g className="rectangles">{mapSections.filter(e => e.section_type === 0).map((item, index) => ( <rect key={"sec_" + item.event_section_id} id={"ga-toggle-" + item.event_section_id} data-section-name={item.display_label} width={item.width} height={item.height} x={item.x} y={item.y} className={styles.sectionBase} onClick={e => sectionClick( item.seats_available, item.event_section_id, item.membership_seat_section_id )} onMouseEnter={e => sectionMouseEnter( item.seats_available, item.event_section_id, item.label, item.price_category_id, item.membership_seat_section_id, item.centroid.x, item.centroid.y )} onMouseLeave={e => setDisplayGaTooltipHover(undefined)} style={item.membership_seat_section_id > 0 ? null : categories.some(r => r.price_category_id === item.price_category_id) === true && item.seats_available > 0 ? {fill:"#" + categories.find(s => s.price_category_id === item.price_category_id).hex_color} : item.seats_available === 0 ? {fill:"rgb(235, 235, 235)",cursor:"default"} : null}></rect> ))}</g>
														<g className={styles.text}>{mapSections.filter(e => e.section_type === 0 && e.label_visible === 1).map((item, index) => ( <text key={"text_" + item.event_section_id} x={item.x + ( item.width / 2)} y={item.y + ( item.height / 2)} textAnchor="middle" dominantBaseline="central" fontSize="12" fontFamily="Helvetica, Arial, sans-serif" fill="white" pointerEvents="none" style={item.width > 60 ? {fontSize:"48px"} : {fontSize:"24px"}}>{item.display_label}</text> ))}</g>
														<g className="polygons">{mapSections.filter(e => e.section_type === 2).map((item, index) => ( <polygon key={"sec_" + item.event_section_id} id={"ga-toggle-" + item.event_section_id} data-section-name={item.display_label} points={item.polygon_points} className={styles.sectionBase} onClick={e => sectionClick( item.seats_available, item.event_section_id, item.membership_seat_section_id )} onMouseEnter={e => sectionMouseEnter( item.seats_available, item.event_section_id, item.label, item.price_category_id, item.membership_seat_section_id, item.centroid.x, item.centroid.y )} onMouseLeave={e => setDisplayGaTooltipHover(undefined)} style={item.membership_seat_section_id > 0 ? null : categories.some(r => r.price_category_id === item.price_category_id) === true && item.seats_available > 0 ? {fill:"#" + categories.find(s => s.price_category_id === item.price_category_id).hex_color} : item.seats_available === 0 ? {fill:"rgb(235, 235, 235)",cursor:"default"} : null}></polygon> ))}</g>
														<g className="tables">{mapSections.filter(e => e.section_type === 3).map((item, index) => ( <g className="table_group"><circle className={styles.table_select} onClick={e =>addTable(item.event_section_id)} key={"table_" + item.event_section_id} cx={item.x} cy={item.y} fill="black" r={item.width}></circle><text key={"table_text_" + item.event_section_id} x={item.x} y={item.y} textAnchor="middle" dominantBaseline="central" fontSize="12" fontFamily="Helvetica, Arial, sans-serif" fill="white">{item.display_label}</text></g> ))}</g>
														<g className="seats">{ticketsAvailableMap.map((item, index) => ( <SeatSelect isSelected={item.isSelect} removeSelectedTicket={e => removeSelectedTicket(index, item.uuid)} key={index} event_seat_uuid={item.uuid} seat_title={item.s} sub_section_title={item.r} seat_x={item.x} seat_y={item.y} display_label={item.sec} seat_add_to_cart={e => seatAddToCart(item.uuid, item.sec, item.r, item.s, item.pcid, item.as, item.rv, item.esid)} seat_info={e => seatInfo(item.uuid, item.sec, item.r, item.s, item.pcid, item.as, item.rv, item.ess, item.x, item.y)} seat_info_hide={e => setTooltipData(undefined)} status={item.ess} accessible_seating={item.as} ticket_type_filter={ticketTypesFilter} price_category_id={item.pcid} loading_categories={loadingCategories} categories={categories} membership_url_string={membership.url_string} event_url_string={event.url_string} display_unlock_modal={displayUnlockModal} unlocked_array={unlockedArray} membership_seat_map_id={event.membership_seat_map_id} /> ))}</g>
													</svg>
												</TransformComponent>
											</Fragment>
										);
									}}
								</TransformWrapper>
								{rightListHover && rightListHover.posX && rightListHover.posY ? (
									<div id="list-info" className={styles.tooltipContainer}>
										<div id="tooltipBubble" className={styles.tooltipBubble} style={{transform: `translate(${rightListHoverPosition.x}px, ${rightListHoverPosition.y}px) translate(-50%, calc(-100% - 15px))`}}>
											<CurrencySymbol currency={event.currency} />{( rightListHover.prices[0].price / 100 ).toFixed(0)}
										</div>
									</div>
								) : null}
								{tooltipData != undefined ? (
									<div id="seat-wrapper" className={styles.seatHoverContainer}>
										<div className={styles.seatWrapper} style={{transform: `translate(${tooltipData.x}px, ${tooltipData.y}px) ${tooltipData.placement == 'bottom' ? "translate(-50%, 8px)" : "translate(-50%, calc(-100% - 8px))"}`}}>
											<div id="seat-info" className={styles.seatHover}>
												<div className={styles.seatImage}></div>
												<div className={styles.seatInfoPadding}>
													{categories.some(a => a.price_category_id == tooltipData.price_category_id) ? ( <div className={styles.seatInfoPriceCategory}>{categories.find(a => a.price_category_id == tooltipData.price_category_id).title}</div> ) : null}
													<div className={styles.seatInfoText}><span>SEC</span> {tooltipData.section} • <span>ROW</span> {tooltipData.row} • <span>SEAT</span> {tooltipData.seat}</div>													
													<div className={styles.seatInfoPrice}>
														{categories.find(a => a.price_category_id == tooltipData.price_category_id).password === 1 && unlockedArray.some(item => tooltipData.price_category_id == item.price_category_id) === false ? (
															<div className={styles.ratBNc}><LockOutlined className={styles.pGBv5x} /> {categories.find(a => a.price_category_id == tooltipData.price_category_id).title}</div>
														) : (
															<Pricing event_id={event.event_id} absorb_ticket_fees={event.absorb_ticket_fees} categories={categories} price_category_id={tooltipData.price_category_id} currency={event.currency} companion_rules={companionRules} membership_categories={membershipCategories} />
														)}
													</div>
												</div>
											{tooltipData.event_seat_status === 8 ? ( <div className={styles.resaleNotice} style={{paddingLeft: 8}}>Resale ticket - click to view</div> ) : null}
											{tooltipData.restricted_view === 1 ? ( <div className={styles.restrictedView}><img src="data:image/png;base64,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" /> Obstructed View</div> ) : null}
											</div>
										</div>
									</div>
								) : null}
								{displayGaTooltipHover != undefined ? (
									<div id="ga-wrapper">
										<div className={styles.seatWrapper} style={{transform: `translate(${displayGaTooltipHover.x}px, ${displayGaTooltipHover.y}px) ${displayGaTooltipHover.placement == 'bottom' ? "translate(-50%, 15px)" : "translate(-50%, calc(-100% - 15px))"}`}}>
											<div id="ga-info" className={styles.seatHover}>
												<div className={styles.seatImage}></div>
												<div className={styles.seatInfoPadding}>
													{categories.some(a => a.price_category_id == displayGaTooltipHover.price_category_id) ? ( <div className={styles.seatInfoPriceCategory}>{categories.find(a => a.price_category_id == displayGaTooltipHover.price_category_id).title}</div> ) : null}
													<div className={styles.seatInfoText}><span>SEC</span> {displayGaTooltipHover.label.toUpperCase()}</div>
													<div className={styles.seatInfoPrice}>
														{categories.find(a => a.price_category_id == displayGaTooltipHover.price_category_id)?.password === 1 && unlockedArray.some(item => displayGaTooltipHover.price_category_id == item.price_category_id) === false ? (
															<div className={styles.ratBNc}><LockOutlined className={styles.pGBv5x} /> {categories.find(a => a.price_category_id == displayGaTooltipHover.price_category_id).title}</div>
														) : (
															<Pricing event_id={event.event_id} absorb_ticket_fees={event.absorb_ticket_fees} categories={categories} price_category_id={displayGaTooltipHover.price_category_id} currency={event.currency} companion_rules={companionRules} membership_categories={membershipCategories} />
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
								) : null}
								<Legend event_id={event.event_id} categories={categories} loading_categories={loadingCategories} ticket_resale={event.ticket_resale} />
							</div>
						</div>
					)}
					<div id="termsText" className={styles.termsText}>By continuing past this page, you agree to our <a rel="noopener noreferrer" href="/legal/terms" target="_blank">Terms of Use.</a></div>
				</aside>
				<div className={styles.mainContent}>
					<section id="eventHeader" className={styles.eventHeader} style={{backgroundColor:'#' + org.background_color}}>
						<div className={styles.eventHeaderContent}>
							{ event.banner_image != null && event.banner_image.length > 0 ? ( <div className={styles.photoContainer + " " + styles.splitContent}><img src={"https://d2jun3ty2bmcrf.cloudfront.net/event/" + event.event_id + "/" + event.banner_image} alt={event.title} title={event.title} /></div> ) : (null)}
							<div className={styles.splitContent + " " + styles.rightContent}>
								<h1 style={{color:getContrast(org.background_color)}}>{event.title}</h1>
								<div className={styles.eventInfo}><div className={styles.dateTime} style={{color:getContrast(org.background_color)}}>{event.formatted_event_start_date_full}</div><span className={styles.divider} style={{color:getContrast(org.background_color)}}> | </span><div className={styles.venue} style={{color:getContrast(org.background_color)}}>{ event.venue_id != null ? ( event.venueTitle ) : ( 'TBA' ) }</div></div>
								<div className={styles.eventBtns}>
									<button onClick={e => setDisplayInfoModal(true)} className={styles.eventButton} style={{color:getContrast(org.background_color),borderColor:getContrast(org.background_color)}}><InfoOutlined style={{fill:getContrast(org.background_color),width:"15px"}} alt="Info Icon" /> Info</button>
									<button onClick={e => setDisplayContactModal(true)} className={styles.eventButton} style={{color:getContrast(org.background_color),borderColor:getContrast(org.background_color)}}><EmailOutlined style={{fill:getContrast(org.background_color),width:"15px"}} alt="Email Icon" /> Contact {t.organizer.charAt(0).toUpperCase() + t.organizer.slice(1)}</button>
								</div>
							</div>
						</div>
					</section>
					{categories.filter(a => a.password === 1).length > 0 && selected.length === 0 ? (
						<button className={styles.gVsZRU} onClick={e => setUnlockModal(true)} style={{color:"#"+org.background_color}}>
							<div className={styles.hzpbVy}>
								<LockOutlined style={{fill:"#"+org.background_color}} />
								<strong style={{color:"#"+org.background_color}}>Enter offer code</strong>
							</div>
							<KeyboardArrowRight style={{fill:"#"+org.background_color}} />
						</button>
					) : null}
					{selected.length === 0 && displayGaTooltip === false ? (
						<div className={styles.jfxwXx}>
							{loadingMap === false ? ( <div className={styles.gMNWCe}></div> ) : null}
							{displayFilter === true ? (
								<div className={styles.kPKLqk}>
									<div className={styles.eNzsjB}>
										<div className={styles.fmonEo}>
											<h3 className={styles.shVLG}>Ticket Types</h3>
											{ticketTypesFilter.length > 0 ? ( <button className={styles.hqBCdc} onClick={e => setTicketTypesFilter([])}>Clear All</button> ) : null}
										</div>
										<div className={styles.idwvsy}><TicketTypeFilter event_id={event.event_id} loading_categories={loadingCategories} categories={categories} ticket_type_filter={ticketTypesFilter} org_background_color={org.background_color} add={addToTicketTypeFilter} remove={removeFromTicketTypeFilter} currency={event.currency} /></div>
									</div>
								</div>
							) : null}
						</div>
					) : null}
					{loadingMap === true ? ( <div className={styles.ticketsListLoading}><img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/login-loading.svg" alt="Loading..." title="Loading..." className={styles.ticketsListLoadingImg} width="100px" height="100px" /></div> ) : ( <ReservedSeatingTicketList event_id={event.event_id} absorb_ticket_fees={event.absorb_ticket_fees} absorb_transaction_fees={event.absorb_transaction_fees} url_string={event.url_string} utc_booking_start_date={event.utc_booking_start_date} utc_booking_finish_date={event.utc_booking_finish_date} formatted_countdown_booking_start_date={event.formatted_countdown_booking_start_date} updatePriceIdOnSelected={updatePriceIdOnSelected} ticketsAvailableList={ticketsAvailableList} selected={selected} cart={cart} currency={event.currency} selected_height={selectedHeight} ticket_limit={event.ticket_limit} loadingList={loadingList} removeSelectedTicket={removeSelectedTicket} addToCartLoading={addToCartLoadingSwitch} handleUnitsChange={handleUnitsChange} submit_selected={submitSelected} venue_id={event.venue_id} venue_url_string={event.venue_url_string} org_title={org.name} org_url_string={org.url_string} orgBackgroundColor={org.background_color} membership_seat_map_id={event.membership_seat_map_id} display_ga_tooltip={displayGaTooltip} tracking_pixels={tracking_pixels} categories={categories} map_sections={mapSections} set_hover_right_list={setRightListHover} on_section_click={sectionClick} tickets_available={ticketsAvailableMap} event_ticket_limit={event.ticket_limit} focal_point={mapFocalPoint} seat_add_to_cart={seatAddToCart} companion_rules={companionRules} /> )}
					{displayGaTooltip === true && selected.length === 0 ? ( <div id="ga-info-right" className={styles.gaList}><GeneralAdmissionSelectTooltip event_id={event.event_id} currency={event.currency} event_section_id={selectedEventSectionId} background_color={org.background_color} addToCartLoading={addToCartLoadingSwitch} event_url_string={event.url_string} membership_url_string={membership.url_string} purchase_timeout={event.purchase_timeout} window_width={windowWidth} ga_close={gaTicketsHide} tracking_pixels={tracking_pixels} unlocked_array={unlockedArray} companion_rules={companionRules} /></div> ) : null}
				</div>
			</div>
			{ displayTicketLimitModal === true ? ( <div className={styles.dnbPHu}><div className={styles.jRvHRz}>
				<div className={styles.jcdXmg} style={{color:getContrast(org.background_color), backgroundColor:'#' + org.background_color}}><div className={styles.esvJaL}>Ticket Limit Reached</div><button title="Close Pop Up" onClick={e => setDisplayTicketLimitModal(false)} className={styles.iQHvCt} style={{color:getContrast(org.background_color)}}><Close /></button></div>
				<div className={styles.modalContent}>
					<div className={styles.infoEventDetails}>
						<p>Oops, this one would exceed the ticket limit of <b>{event.ticket_limit}</b>. Please change your selection if you really want this seat.</p>
					</div>
				</div>
			</div></div> ) : null}
			{ addToCartLoading === true ? (
				<div className={styles.dnbPHu}><div className={styles.jRvHRz}><div className={styles.bf2258}>
					<p><BrandedLoading logo_image={org.logo_image} background_color={org.background_color} url_string={org.url_string} /></p>
					<p className={styles.m7bvRf}>Sit tight, we're securing your tickets...</p>
					<span className={styles.qB3Tg0}>Tickets are not secured until payment has been confirmed.</span>
				</div></div></div>
			) : null}
			{ addToCartError === true ? (
				<div className={styles.dnbPHu}><div className={styles.jRvHRz}>
					<p><b>We apologize. We are unable to complete your request on this device.</b></p>
					<p>So that you may continue to shop, we recommend using a different device (laptop, phone, tablet, etc.). Using a shared device? Make sure you're logged into your {org.name} account.</p>
					<button onClick={e => setAddToCartError(false)}>OK</button>
				</div></div>
			) : null}
			{ displayAccessibleModal === true ? (
				<div className={styles.dnbPHu}>
					<div className={styles.jRvHRz}>
						<div className={styles.jcdXmg} style={{color:getContrast(org.background_color), backgroundColor:'#' + org.background_color}}><div className={styles.esvJaL}>Terms of Use</div></div>
						<div className={styles.modalContent}>
							<div className={styles.infoEventDetails}>
								<p><b>IMPORTANT:</b> Accessible tickets are for fans with accessible needs and their companions only.</p>
								<p>You have selected accessible seating tickets.</p>
								<p>Please agree to the following terms and conditions to start your purchase: Per order delivery and/or processing fees are added when applicable. Accessible seating locations (i.e. Wheelchair spaces and companion seats) are intended for use by individuals with disabilities and their companions. By purchasing tickets for accessible seating through {org.name}, you represent that you or a member of your party has a disability that requires accessible features provided by the seating locations being purchased. {org.name} may investigate potential misuse of accessible seating where there is good cause to believe that such seating has been purchased fraudulently. In appropriate cases {org.name} may, in its sole discretion, cancel an order for accessible seating that it believes to be fraudulent or improper and reserves the right to pursue legal action against individuals who fraudulently purchase tickets for accessible seating. The venue hosting the event also reserves the right to relocate to other seats, patrons who have tickets for accessible seating locations, but who do not need accessible seating. By clicking on the "Continue" button, or otherwise using this website, you agree to the Terms of use.</p>
							</div>
						</div>
						<div className={styles.accessibleModalDialogFooter}>
							<div className={styles.splitContentPrimary}>
								<input type="checkbox" className={styles.checkboxModal} onClick={e => setAccessibleModalAgree(!accessibleModalAgree)} />
								<label className={styles.checkboxLabel}>I agree</label>
							</div>
							<div className={styles.splitContentSecondary}>
								<button title="Continue" className={styles.modalDialogButton} style={{color:getContrast(org.background_color), backgroundColor:'#' + org.background_color}} disabled={accessibleModalAgree === false} onClick={e => setDisplayAccessibleModal(false)}>Continue</button>
							</div>
						</div>
					</div>
				</div>
			) : null}
			{ unlockModal === true ? ( <div className={styles.dnbPHu}><div className={styles.jRvHRz}>
				<div className={styles.jcdXmg} style={{color:getContrast(org.background_color), backgroundColor:'#' + org.background_color}}><div className={styles.esvJaL}>Unlock Offers</div><button title="Close Unlock Code Pop Up" onClick={e => setUnlockModal(false)} className={styles.iQHvCt} style={{color:getContrast(org.background_color)}}><Close /></button></div>
				<div className={styles.modalContent}>
					<div className={styles.etjCi}>
						<div className={styles.eDxKvh}>
							<label className={styles.ihzkcn}><LockOutlined /> Enter Offer Code</label>
							<form className={styles.uBskH} onSubmit={e => e.preventDefault()}>
								<input className={styles.IfXgG} placeholder={"Enter code"} value={unlockCode} onChange={e => { setUnlockCode(e.target.value.trim()); setUnlockCodeError(undefined);}} />
								<button title="Submit Promo Code for Validation" className={styles.fElLEi} type={"button"} style={{color:getContrast(org.background_color), backgroundColor:'#' + org.background_color}} onClick={e => validateOfferCode(unlockCode)}>Submit</button>
							</form>
							{unlockCodeError != undefined ? ( <div className={styles.gKhiXe}><WarningOutlined /><p className={styles.iSLLoZ}>{unlockCodeError}</p></div> ) : null}
							<p className={styles.gjkRdi}>Make sure this is not your {org.name} account password.</p>
						</div>
					</div>
				</div>
			</div></div> ) : null}
			{addToCartLoading === false && submitError != undefined ? ( <div className={styles.dnbPHu}><div className={styles.jRvHRz}><div className={styles.jcdXmg} style={{color:getContrast(org.background_color), backgroundColor:'#' + org.background_color}}><div className={styles.esvJaL}>Oops! Something went wrong...</div></div><div className={styles.modalContent}><div className={styles.infoEventDetails}><p className={styles.tqNM8u}>{submitError}</p><p className={styles.tqNM8u}><button className={styles.fV6tgB} onClick={e => { setSubmitError(undefined); setValidateFinish(false);}} style={{color:getContrast(org.background_color), backgroundColor:'#' + org.background_color}}>I'll fix this up</button></p></div></div></div></div> ) : null}
			{displaySoldOutModal === true ? ( <div className={styles.dnbPHu}><div className={styles.jRvHRz}>
				<div className={styles.jcdXmg} style={{color:getContrast(org.background_color), backgroundColor:'#' + org.background_color}}><div className={styles.esvJaL}>Sold Out</div><button title="Close Pop Up" onClick={e => setDisplaySoldOutModal(false)} className={styles.iQHvCt} style={{color:getContrast(org.background_color)}}><Close /></button></div>
				<div className={styles.modalContent}>
					<div className={styles.infoEventDetails}>
						<p style={{textAlign:"center"}}>{event.title} is sold out.</p>
						{event.ticket_resale === 1 ? ( <p style={{textAlign:"center"}}>Resale tickets will appear as they are listed by customers who can no longer attend.</p> ) : null}
					</div>
				</div>
			</div></div> ) : null}
			{specialInstructions != undefined && specialInstructions.trim().length > 10 && displaySoldOutModal === false ? (
				<div className={styles.dnbPHu}><div className={styles.jRvHRz}>
					<div className={styles.jcdXmg} style={{color:getContrast(org.background_color), backgroundColor:'#' + org.background_color}}><div className={styles.esvJaL}>Important Information</div><button title="Close Pop Up" onClick={e => setSpecialInstructions(undefined)} className={styles.iQHvCt} style={{color:getContrast(org.background_color)}}><Close /></button></div>
					<div className={styles.modalContent}><div className={styles.infoEventDetails} dangerouslySetInnerHTML={{__html: specialInstructions}}></div></div>
				</div></div>
			) : null}
			{displayOrphanSeatWarningModal ? ( <div className={styles.dnbPHu}><div className={styles.jRvHRz}><div className={styles.rGGBaz}><div className={styles.kHQwEs}><div className={styles.btGYzO}><div className={styles.bMBQdI}><WarningOutlined /> You have left a single empty seat</div><button className={styles.gigyPC} onClick={e => setDisplayOrphanSeatWarningModal(false)}><Close /></button></div><div className={styles.lbLHYK}>Please update your selection to leave at least two empty seats together to continue.</div></div></div></div></div> ) : null}
			{displayPriceNotSelectedModal ? ( <div className={styles.dnbPHu}><div className={styles.jRvHRz}><div className={styles.rGGBaz}><div className={styles.kHQwEs}><div className={styles.btGYzO}><div className={styles.bMBQdI}><WarningOutlined /> You haven't selected a price</div><button className={styles.gigyPC} onClick={e => setDisplayPriceNotSelectedModal(false)}><Close /></button></div><div className={styles.lbLHYK}>One of your selected seats does not have a price selected on it. Please fix and then click 'Next' again.</div></div></div></div></div> ) : null}
			{displayContactModal ? ( <div className={styles.dnbPHu}><div className={styles.jRvHRz}><div className={styles.jcdXmg} style={{color:getContrast(org.background_color), backgroundColor:'#' + org.background_color}}><div className={styles.esvJaL}>Contact the Event Organizer</div><button onClick={e => setDisplayContactModal(false)} className={styles.iQHvCt} style={{color:getContrast(org.background_color)}}><Close /></button></div><div className={styles.modalContent}><div className={styles.infoEventDetails}><ContactForm color={getContrast(org.background_color)} backgroundColor={"#" + org.background_color} url_string={event.url_string} /></div></div></div></div> ) : null}
			{displayInfoModal ? ( 
				<div className={styles.dnbPHu}>
					<div className={styles.jRvHRz}>
						<div className={styles.jcdXmg} style={{color:getContrast(org.background_color), backgroundColor:'#' + org.background_color}}><div className={styles.esvJaL}>More Info</div><button onClick={e => setDisplayInfoModal(false)} className={styles.iQHvCt} style={{color:getContrast(org.background_color)}}><Close /></button></div>
						<div className={styles.modalContent}>
							<div className={styles.breadcrumbs}>
								<ol className={styles.breadcrumbList}>
									<li className={styles.breadcrumbItems + " " + styles.breadcrumbLogo}><a href={"/org/" + org.url_string}>{ org.favicon != null && org.favicon.length > 0 ? ( <Image alt={org.name} title={org.name} src={"https://d2jun3ty2bmcrf.cloudfront.net/org/" + org.url_string + "/" + org.favicon} height={16} width={16} /> ) : org.logo != null && org.logo.length > 0 ? ( <Image src={"https://d2jun3ty2bmcrf.cloudfront.net/org/" + org.url_string + "/" + org.logo} alt={org.name} title={org.name} height={16} width={32} /> ) : ( <img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/event-breadcrumb-logo.png" alt="INTIX" title="INTIX" /> )}</a></li>
									<li className={styles.breadcrumbItems}><a href="/discover">All Tickets</a></li>
									<li className={styles.breadcrumbItems}><a href={`/org/${org.url_string}`}>{org.name}</a></li>
								</ol>
							</div>
							<div className={styles.infoEventDetails}>
								<h2 className={styles.headingPrimary}>{event.title}</h2>
								<div className={styles.modalSection}>
									<div className={styles.dateVenue}>
										<div className={styles.dateVenueRow}>
											<div className={styles.dateVenueIcon}><CalendarToday /></div>
											<div className={styles.dateVenueTitle}>Date</div>
											<div className={styles.dateVenueText}>{event.formatted_event_start_date_full}</div>
										</div>
										<div className={styles.dateVenueRow}>
											<div className={styles.dateVenueIcon}><LocationCity /></div>
											<div className={styles.dateVenueTitle}>Venue</div>
											<div className={styles.dateVenueText}>{event.venue_id != null ? ( <Fragment><a href={"/venue/" + event.venue_url_string} className={styles.dateVenueLink}>{event.venueTitle}</a><br />{event.suburb}, {event.state}</Fragment> ) : ( 'TBA' )}</div>
										</div>
									</div>
								</div>
								{long_description.length === 0 ? null : ( <div className={styles.modalSection} id={"long-description"}><div className={styles.ivUHTG} dangerouslySetInnerHTML={{__html: long_description}}></div></div> )}
								<div className={styles.modalSection}>
									<Lineup event_id={event.event_id} />
									<h3>Ticket Limits</h3>
									<p>There is a limit of <b>{event.ticket_limit}</b> tickets for this event.</p>
									<h3>Accessible Tickets</h3>
									<p>{org.name} strive to make it as easy as possible to purchase accessible seating tickets for venues across the country. Most venues offer accessible seating areas to accommodate their guests. Availability and type of accessible seating tickets will vary based on each venue's policies and/or the type of event taking place. Note: Venues are solely responsible for establishing their own accessible seating ticket policies. Some venues sell all or a portion of their accessible seating tickets only through their box office. For further information on purchasing accessible tickets, <a onClick={switchToContactFormModal}>contact the organiser</a>.</p>
									<span className={styles.pricesIn}>Prices are in {event.currency}</span>
								</div>
								<div className={styles.modalSection} id={"faqs"}>
									{faqs.length > 0 ? (
										<section className={styles.pageBlock}>
											<div className={styles.container}>
												<ul className={styles.hNBgt}>
													{faqs.map((faq, i) => ( 
														<li className={styles.dVBnys} key={"faq_" + i}>
															<FaqContent title={faq.title} background_color={"ffffff"} html_content={faq.html_content} list_length={faqs.length} />
														</li> 
													))}
												</ul>
											</div>
										</section>
									) : null}
								</div>
							</div>
						</div>
					</div>
				</div>
			) : null}
			{helpModalDisplay ? (
				<div className={styles.dnbPHu}>
					<div className={styles.jRvHRz}>
						<div className={styles.jcdXmg} style={{color:getContrast(org.background_color), backgroundColor:'#' + org.background_color}}><div className={styles.esvJaL}>How to use this map</div><button onClick={e => setHelpModalDisplay(false)} className={styles.iQHvCt} style={{color:getContrast(org.background_color)}}><Close /></button></div>
						<div className={styles.modalContent}>
							<div className={styles.infoEventDetails}>
								<div className={styles.modalSection}>
									<h3>Available Reserved Seating</h3>
									<p>Available Reserved Seats are shown by colored dots that are not light grey. You can select specific seats by clicking on them that now appear in your cart. You can then adjust the price on the seat if more than one price on the seat is available.</p>
									<h3>General Admission Seating</h3>
									<p>General Admission areas are defined by box areas which can be clicked on to access the pricing on the section.</p>
									<h3>Unlock Codes</h3>
									<p>Some seats are locked behind a password and only available if you know the password. You can click on the seat and enter the password to access the seat.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			) : null}
		</Layout>
	)
}

function TicketTypeFilter({ event_id, categories, loading_categories, ticket_type_filter, remove, add, currency, org_background_color }){
	if( loading_categories === true ){ return ( <div>loading...</div> ) }
	return (
		<ul className={styles.gLwwcA}>
			{categories.filter((a,b) => a.membership_category_id === 0 ).map((item, index) => ( 
				<li className={styles.dRfsLC} data-id={item.price_category_id} key={"type_category_" + item.price_category_id} onClick={e => ticket_type_filter.indexOf(item.price_category_id) > -1 ? remove(item.price_category_id) : add(item.price_category_id)}>
					<div className={styles.cutAVh}>
						<div className={styles.fQYtmH}>
							<label className={styles.bJjqSB}>
								<span className={styles.fZbtUi}>{item.title} <TicketTypeFilterMin event_id={event_id} price_category_id={item.price_category_id} currency={currency} /></span>
								<div className={styles.AFfAF}>{ticket_type_filter.indexOf(item.price_category_id) > -1 ? ( <span className={styles.ruvmzp} style={{backgroundColor:'#' + org_background_color, borderColor:getContrast(org_background_color)}}><svg className={styles.jQUKI} style={{fill:getContrast(org_background_color)}} viewBox="0 0 24 24" width="1rem" height="1rem" aria-hidden="true" focusable="false"><path d="M22.72 4.7l-.4-.42a.93.93 0 00-1.34 0L8.5 17.03l-5.38-5.7a.93.93 0 00-1.36 0l-.49.5a1 1 0 000 1.35l6 6.3a1.7 1.7 0 002.45 0l13-13.41c.37-.38.37-1 0-1.37"></path></svg></span> ) : ( <span className={styles.foSwxt}></span> )}</div>
							</label>
						</div>
					</div>
				</li>
			))}
		</ul>	
	)
}

function TicketTypeFilterMin({ event_id, price_category_id, currency }){
	const [loading, setLoading] = useState(true);
	const [prices, setPrices] = useState([]);

	useEffect(() => { getPrices(); }, []);

	function getPrices(){
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event_id + '/price_category/' + price_category_id + '/prices', { method: 'GET', headers: { "Content-Type": "application/json" } })
		.then(response => { if(response.ok){ return response.json(); } throw new Error('fetch error - /price_category/:___/prices'); })
		.then(data => { if(data.error){ } else { setPrices(data); } })
		.catch(error => { console.log(error); })
		.finally(() => { setLoading(false); })
	}

	return ( <span className={styles.pHn7gb}>{loading === false && prices.length > 0 ? ( <Fragment>{prices.length > 1 ? " from " : null}<CurrencySymbol currency={currency} />{Math.min(...prices.map(item => ( item.total_cost / 100 ))).toFixed(2)}</Fragment> ) : null}</span> )
}

function Pricing({ price_category_id, currency, categories, companion_rules, membership_categories }){

	let minPrice = 0;
	let maxPrice = 0;

	if( price_category_id > 0 ){
		let targetCategory = categories?.find(cat => cat.price_category_id === price_category_id);
		let isMembership = false;

		if (membership_categories && targetCategory.membership_category_id > 0){
			targetCategory = membership_categories.find(cat => cat.membership_category_id === targetCategory.membership_category_id);
			isMembership = true;
		} 

		if (!targetCategory) return ( <div className={styles.reserved_price_text} id={"pricing_price_list"}>Unavailable</div> );

		const sourcePrices = isMembership ? (targetCategory.types || targetCategory.prices) : targetCategory.prices;

		if (!sourcePrices || sourcePrices.length === 0) return ( <div className={styles.reserved_price_text} id={"pricing_price_list"}>{!isMembership && targetCategory.available_from ? "Available from " + targetCategory.available_from : "Unavailable"}</div> );

		const publicPrices = isMembership ? sourcePrices : sourcePrices.filter(p => {
			const isReward = companion_rules?.some(rule => rule.reward_price_id === p.price_id);
			return !isReward;
		});

		const priceValues = publicPrices.map(p => p.price);

		if (priceValues.length === 0){ return ( <div className={styles.reserved_price_text} id={"pricing_price_list"}>Unavailable</div> ); }

		minPrice = Math.min(...priceValues);
		maxPrice = Math.max(...priceValues);
	}

	return ( 
		<div className={styles.reserved_price_text} id={"pricing_price_list"}>
			<CurrencySymbol currency={currency} />{( minPrice / 100 ).toFixed(2)}
			{maxPrice != minPrice ? (
				<Fragment>&nbsp;- <CurrencySymbol currency={currency} />{( maxPrice / 100 ).toFixed(2)}</Fragment>
			) : null}
		</div>
	)
}

function VenueInformation( props ){
	const [loading, setLoading] = useState(false);
	if( loading === true ){ return ( <Fragment></Fragment> ) }
	return ( <Fragment><p>{props.title}</p><p>{props.venue_id}</p></Fragment> )
}

function Lineup({ event_id }){
	const [loading, setLoading] = useState(false);
	const [artistList, setArtistList] = useState([]);

	useEffect(() => { getArtists(); }, [event_id]);

	function getArtists(){
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event_id + '/artists', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
		.then(response => { if(response.ok){ return response.json(); } throw new Error('fetch error - /artists'); })
		.then(data => { if(data.error){ } else { setArtistList(data); } })
		.catch(error => { console.log(error); })
		.finally(() => { setLoading(false); })
	}

	if( loading ){ return ( <div key="loading_artist_0"><div className={styles.hTRmfd}><img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/login-loading.svg" alt="Loading" title="Loading" width="50" /></div></div> ) }
	if( artistList.length === 0 ){ return null }

	return (
		<Fragment>
			<h3>Line Up</h3>
			<div className={styles.lineupContent}>
				<ul className={styles.kqrCfE}>{artistList.map((artist, index) => ( <li className={styles.goJlZj} key={"artist_" + artist.artist_id}><img src={"https://d2jun3ty2bmcrf.cloudfront.net/artist/" + artist.url_string + "/" + artist.logo_image} alt={artist.title} title={artist.title} /></li> ))}</ul>
			</div>
		</Fragment>	
	)
}

function SeatSelect( props ){
	const router = useRouter();
	function handleClick(){ 
		if( props.categories.find(a => a.price_category_id === props.price_category_id).password === 0 || props.unlocked_array.some(item => props.price_category_id === item.price_category_id) === true ){
			props.seat_add_to_cart(props.isSelected, props.event_seat_uuid, props.display_label, props.sub_section_title, props.seat_title); 
		} else {
			props.display_unlock_modal();
		}
	}
	function handleClearSelected(index, event_seat_uuid){props.removeSelectedTicket(index, event_seat_uuid);};
	function handleMembershipClick(){ Router.push( 'https://am.intix.com/' + props.membership_url_string + '/map?membership_seat_map_id=' + props.membership_seat_map_id); };
	function handleResaleClick(){ window.open('/event/' + props.event_url_string + '/resale', '_blank'); }

	return (
		<Fragment>
			{props.status === 0 && props.price_category_id != 0 && props.categories.some(a => a.price_category_id === props.price_category_id) === true ? ( 
				<Fragment>
					 {props.isSelected === true ? (
						<g key={props.event_seat_uuid} id={"s-" + props.event_seat_uuid} className={styles.isSelected} data-seat-name={props.seat_title} data-seat-row={props.sub_section_title} onClick={(index) => handleClearSelected(index, props.event_seat_uuid)}>
							<circle r="5" cx={props.seat_x} cy={props.seat_y} onMouseEnter={e => props.seat_info()} onMouseLeave={e => props.seat_info_hide(props.event_seat_uuid)}></circle>
							{props.accessible_seating === 0 ? ( 
								<path transform={"rotate(0,50,50) translate(" + (props.seat_x - 4) + "," + (props.seat_y - 3) + ") scale(0.08) matrix(1, 0, 0, 1, 0, 0)"} d="M86.67 0 33.33 53.33 13.33 33.33 0 46.67 33.33 80 100 13.33 86.67 0 Z" fill="#ffffff"></path>
							) : (
								<path style={{fill:"rgb(255,255,255)"}} transform={"rotate(0, 50, 50) scale(0.1) translate(" + ( ( props.seat_x * 10 ) - 50 ) + "," + ( ( props.seat_y * 10 ) - 50 ) + ")"} d="M62.34,55.7825 C65.0175,62.15 67.7475,68.495 70.455,74.855 C70.56,75.0875 70.65,75.32 70.7925,75.62 C71.0025,75.545 71.235,75.47 71.4375,75.395 C74.865,74.045 78.2925,72.71 81.72,71.36 C81.8775,71.285 82.0575,71.2475 82.215,71.2025 L82.215,71.075 C81.6225,69.695 81.03,68.3525 80.43,66.9425 C78.3075,67.7225 76.215,68.465 74.0625,69.245 C73.95,69.035 73.8675,68.8325 73.7775,68.645 C71.1225,62.5475 68.4825,56.4425 65.8575,50.33 C65.67,49.88 65.4375,49.73 64.95,49.745 C58.7925,49.7975 52.62,49.82 46.425,49.865 C46.2525,49.865 46.08,49.8575 45.8625,49.835 C45.7725,48.62 45.675,47.435 45.5775,46.1825 L59.835,46.1825 L59.835,40.775 L45.0525,40.775 C44.82,36.845 44.61,32.9825 44.385,29.09 C44.73,29.015 45.0375,28.9625 45.33,28.88 C47.925,28.19 49.68,25.775 49.5975,23.015 C49.5225,20.435 47.5575,18.1325 44.985,17.6075 C44.835,17.5775 44.6925,17.525 44.535,17.4875 L43.125,17.4875 C42.9225,17.54 42.705,17.6 42.51,17.6525 C39.105,18.4775 37.23,22.04 38.4075,25.34 C38.655,26 38.8125,26.7275 38.865,27.44 C39.345,34.01 39.81,40.58 40.275,47.15 C40.44,49.61 40.6275,52.055 40.7625,54.5 C40.8,55.0475 40.9575,55.1975 41.49,55.1825 C48.1275,55.1675 54.765,55.1825 61.3875,55.1675 C61.8975,55.16 62.145,55.295 62.34,55.7825 Z M25.335,59.39 L25.335,62.9225 C25.365,63.0725 25.425,63.23 25.4325,63.38 C26.46,72.6125 33.045,80.015 42.1275,82.0475 C42.915,82.2275 43.74,82.355 44.535,82.5125 L48.66,82.5125 C49.8525,82.2725 51.06,82.115 52.23,81.77 C58.0575,80.0975 62.505,76.61 65.4975,71.3 C65.7,70.94 65.715,70.6625 65.5425,70.2725 C64.4475,68.12 63.405,65.945 62.3475,63.7775 C62.2425,63.59 62.1525,63.425 62.0325,63.1925 C61.8525,63.965 61.71,64.6625 61.53,65.345 C59.5125,72.38 53.07,77.045 45.7875,76.7375 C38.2725,76.4 31.8,70.2275 31.2075,62.7125 C30.735,56.7125 33,51.905 37.8825,48.35 C38.04,48.23 38.2275,47.99 38.22,47.825 C38.0925,45.86 37.935,43.9025 37.7775,41.855 C37.5525,41.945 37.35,42.005 37.17,42.1025 C30.375,45.7175 26.4525,51.3425 25.4475,58.9925 C25.425,59.1275 25.365,59.24 25.335,59.39 Z"></path>
							)}
						</g>
					) : ( 
						<Fragment>
							{props.accessible_seating === 1 ? ( 
								<g key={props.event_seat_uuid} id={"s-" + props.event_seat_uuid} className={styles.isWheelchair} data-seat-name={props.seat_title} data-seat-row={props.sub_section_title} onMouseEnter={e => {props.seat_info()}} onMouseLeave={e => props.seat_info_hide(props.event_seat_uuid)} onClick={e => handleClick()}>
									<circle r="5" cx={props.seat_x} cy={props.seat_y} style={{fill:"#" + props.categories.find(a => a.price_category_id === props.price_category_id).hex_color}}></circle>
									<path transform={"rotate(0, 50, 50) scale(0.1) translate(" + ( ( props.seat_x * 10 ) - 50 ) + "," + ( ( props.seat_y * 10 ) - 50 ) + ")"} d="M62.34,55.7825 C65.0175,62.15 67.7475,68.495 70.455,74.855 C70.56,75.0875 70.65,75.32 70.7925,75.62 C71.0025,75.545 71.235,75.47 71.4375,75.395 C74.865,74.045 78.2925,72.71 81.72,71.36 C81.8775,71.285 82.0575,71.2475 82.215,71.2025 L82.215,71.075 C81.6225,69.695 81.03,68.3525 80.43,66.9425 C78.3075,67.7225 76.215,68.465 74.0625,69.245 C73.95,69.035 73.8675,68.8325 73.7775,68.645 C71.1225,62.5475 68.4825,56.4425 65.8575,50.33 C65.67,49.88 65.4375,49.73 64.95,49.745 C58.7925,49.7975 52.62,49.82 46.425,49.865 C46.2525,49.865 46.08,49.8575 45.8625,49.835 C45.7725,48.62 45.675,47.435 45.5775,46.1825 L59.835,46.1825 L59.835,40.775 L45.0525,40.775 C44.82,36.845 44.61,32.9825 44.385,29.09 C44.73,29.015 45.0375,28.9625 45.33,28.88 C47.925,28.19 49.68,25.775 49.5975,23.015 C49.5225,20.435 47.5575,18.1325 44.985,17.6075 C44.835,17.5775 44.6925,17.525 44.535,17.4875 L43.125,17.4875 C42.9225,17.54 42.705,17.6 42.51,17.6525 C39.105,18.4775 37.23,22.04 38.4075,25.34 C38.655,26 38.8125,26.7275 38.865,27.44 C39.345,34.01 39.81,40.58 40.275,47.15 C40.44,49.61 40.6275,52.055 40.7625,54.5 C40.8,55.0475 40.9575,55.1975 41.49,55.1825 C48.1275,55.1675 54.765,55.1825 61.3875,55.1675 C61.8975,55.16 62.145,55.295 62.34,55.7825 Z M25.335,59.39 L25.335,62.9225 C25.365,63.0725 25.425,63.23 25.4325,63.38 C26.46,72.6125 33.045,80.015 42.1275,82.0475 C42.915,82.2275 43.74,82.355 44.535,82.5125 L48.66,82.5125 C49.8525,82.2725 51.06,82.115 52.23,81.77 C58.0575,80.0975 62.505,76.61 65.4975,71.3 C65.7,70.94 65.715,70.6625 65.5425,70.2725 C64.4475,68.12 63.405,65.945 62.3475,63.7775 C62.2425,63.59 62.1525,63.425 62.0325,63.1925 C61.8525,63.965 61.71,64.6625 61.53,65.345 C59.5125,72.38 53.07,77.045 45.7875,76.7375 C38.2725,76.4 31.8,70.2275 31.2075,62.7125 C30.735,56.7125 33,51.905 37.8825,48.35 C38.04,48.23 38.2275,47.99 38.22,47.825 C38.0925,45.86 37.935,43.9025 37.7775,41.855 C37.5525,41.945 37.35,42.005 37.17,42.1025 C30.375,45.7175 26.4525,51.3425 25.4475,58.9925 C25.425,59.1275 25.365,59.24 25.335,59.39 Z"></path>
								</g>
							) : (
								<g key={props.event_seat_uuid} className={styles.pgb5cd}>
									<circle key={props.event_seat_uuid} id={"s-" + props.event_seat_uuid} data-seat-name={props.seat_title} data-seat-row={props.sub_section_title} r="5" cx={props.seat_x} cy={props.seat_y} className={styles.isAvailable} onMouseEnter={e => props.seat_info()} onMouseLeave={e => props.seat_info_hide(props.event_seat_uuid)} onClick={e => handleClick()} style={props.ticket_type_filter.length > 0 && !props.ticket_type_filter.includes(props.price_category_id) ? {opacity:0.5,fill:"#" + props.categories.find(a => a.price_category_id === props.price_category_id).hex_color} : {fill:"#" + props.categories.find(a => a.price_category_id === props.price_category_id).hex_color}}></circle>
									{props.categories.find(a => a.price_category_id === props.price_category_id).password === 1 && props.unlocked_array.some(item => props.price_category_id === item.price_category_id) === false ? ( <path style={{fill:getContrast(props.categories.find(a => a.price_category_id === props.price_category_id).hex_color)}} transform={"rotate(0, 50, 50) scale(0.1) translate(" + ( ( props.seat_x * 10 ) - 50 ) + "," + ( ( props.seat_y * 10 ) - 50 ) + ")"} d="M68.86,36.57H63.71V28a12,12,0,0,0-12-12H48.29a12,12,0,0,0-12,12v8.57H31.14A5.15,5.15,0,0,0,26,41.71V72.57a5.15,5.15,0,0,0,5.14,5.14H68.86A5.15,5.15,0,0,0,74,72.57V41.71A5.15,5.15,0,0,0,68.86,36.57ZM39.71,28a8.58,8.58,0,0,1,8.57-8.57h3.43A8.58,8.58,0,0,1,60.29,28v8.57H39.71V28ZM50,65a7.84,7.84,0,1,1,7.84-7.84A7.84,7.84,0,0,1,50,65Z"></path> ) : null}
								</g>
							)}
						</Fragment>
					)}
				</Fragment>
			) : props.status === 5 ? ( 
				<circle key={props.event_seat_uuid} id={"s-" + props.event_seat_uuid} className={styles.membership} r="5" cx={props.seat_x} cy={props.seat_y} onMouseEnter={e => props.seat_info()} onMouseLeave={e => props.seat_info_hide(props.event_seat_uuid)} onClick={e => handleMembershipClick()}></circle>
			) : props.status === 8 ? ( 
				<g key={props.event_seat_uuid} id={"s-" + props.event_seat_uuid} className={styles.seat_legend_item_icon} onMouseEnter={e => props.seat_info()} onMouseLeave={e => props.seat_info_hide(props.event_seat_uuid)} onClick={e => handleResaleClick()}>
					<circle key={props.event_seat_uuid} className={styles.membership} r="5" cx={props.seat_x} cy={props.seat_y} style={{fill:"#2acaea"}}></circle>
					<path transform={"rotate(0, 50, 50) scale(0.1) translate(" + ( ( props.seat_x * 10 ) - 50 ) + "," + ( ( props.seat_y * 10 ) - 50 ) + ")"} d="M75.7470835,33 C70.3845835,24.0431235 61.16,18 50.5704165,18 C36.85,18 25.39375,28 21.6670835,41.4382285 L30.17125,41.4382285 C33.5133335,32.8951049 41.3404165,26.7995338 50.5704165,26.7995338 C57.43875,26.7995338 63.5704165,30.2902098 67.67625,35.6573427 L61.2954165,37.6911422 L69.0304165,44.3111888 L76.8195835,50.9778555 L79.96125,40.7680653 L83,30.6107226 L75.7470835,33 L75.7470835,33 L75.7470835,33 Z M50.4729165,74.2062938 C43.5666665,74.2062938 37.4295835,70.7738928 33.3670835,65.4009323 L39.7479165,63.3671327 L32.0129165,56.7470863 L24.1858335,50.0804196 L21.0983335,60.2902098 L18,70.4009326 L25.3016665,68 C30.6641665,77.0151514 39.8995835,82.9475523 50.4783335,83 L50.4783335,82.9475523 C64.19875,82.9475523 75.7091665,73.0524475 79.3275,59.5559442 L70.8720835,59.5559442 C67.5354165,68.1689975 59.6541665,74.2062938 50.4729165,74.2062938 L50.4729165,74.2062938 L50.4729165,74.2062938 Z"></path>
				</g>
			) : ( 
				<circle key={props.event_seat_uuid} id={"s-" + props.event_seat_uuid} className={styles.unavailable} r="5" cx={props.seat_x} cy={props.seat_y}></circle>
			)}
		</Fragment>
	)
}

function ReservedSeatingTicketList({ event_id, currency, selected, cart, ticket_limit, selected_height, org_title, org_url_string, absorb_ticket_fees, absorb_transaction_fees, venue_id, venue_url_string, utc_booking_finish_date, orgBackgroundColor, removeSelectedTicket, updatePriceIdOnSelected, submit_selected, tracking_pixels, orphan_seat_warning, display_ga_tooltip, categories, map_sections, set_hover_right_list, on_section_click, tickets_available, event_ticket_limit, focal_point, seat_add_to_cart, companion_rules }){
	const [tabSelected, setTabSelected] = useState(1);
	const [ticketsWanted, setTicketsWanted] = useState(3);

	return (
		<Fragment>
			{ Math.round((new Date()).getTime() / 1000) > utc_booking_finish_date ? (
				<div className={styles.khARhF}>
					<div className={styles.faAGPG}>
						<div className={styles.hZDmOj}>
							<WarningOutlined className={styles.gghUfo} />
							<div className={styles.zGyTm}>Ticket sales for this event have now finished.</div>
						</div>
						<div className={styles.ggGxPL}>Please contact the event organiser for further information.</div>
					</div>
					<div className={styles.gozxfc}>
						<h2 className={styles.thgEQ}>More options</h2>
						<div className={styles.bkNgUF}>
							<div className={styles.YXzQw}>
								<div className={styles.bKnZAm}>
									<div className={styles.cYIvcn}><EventNoteOutlined /></div>
									<p className={styles.dImlOW}>Check out other dates for this artist.</p>
									<a href={`/org/${org_url_string}`} type="button" className={styles.lbXfRJ} style={{backgroundColor:"#"+orgBackgroundColor,color:getContrast(orgBackgroundColor)}}><span className={styles.FEMVG}><span className={styles.lfiYPa}>View other dates</span></span></a>
								</div>
							</div>
							{venue_id != null ? (
								<div className={styles.YXzQw}>
									<div className={styles.bKnZAm}>
										<div className={styles.cYIvcn}><LocationOnOutlined /></div>
										<p className={styles.dImlOW}>Check out other events at this venue.</p>
										<a href={`/venue/${venue_url_string}`} type="button" className={styles.lbXfRJ} style={{backgroundColor:getContrast(orgBackgroundColor),color:"#"+orgBackgroundColor,borderColor:"#"+orgBackgroundColor}}><span className={styles.FEMVG}><span className={styles.lfiYPa}>More events at venue</span></span></a>
									</div>
								</div>
							) : null}
						</div>
					</div>
				</div>
			) : (
				<Fragment>
					{ selected.length > 0 ? ( 
						<div className={styles.quickPicksPaneOpen}>
							<div className={styles.quickPicksPaneOpenContainer}>
								{ selected.length > 0 ? (
									<Fragment>
										<h2 id="selectedTicketsHeader" className={styles.bagTitle}>Your Selected Tickets</h2>
										<div id="selectedTicketsAdditional" className={styles.bagAdditional}>Tickets are not secured until payment has been confirmed.</div>
										{ticket_limit > 0 ? ( <div id="selectedTicketsAdditional" className={styles.bagAdditional}>Event ticket limit: {ticket_limit}</div>) : null}
										<PricesAvailableWarning selected={selected} price_categories={categories} org_background_color={orgBackgroundColor} />
										<ul className={styles.ticketBagTicketList} style={typeof window !== 'undefined' && window.innerWidth > 767 ? {height: selected_height + "px"} : {}}>
											{selected.map((item, index) => ( 
												<li key={index} className={styles.ticketListItem}>
													<div className={styles.ticketStubContent}>
														<div className={styles.tooltipContent}>
															<div className={styles.tooltipSRS}>
																<div className={styles.srsSet}>
																	<div className={styles.srsLabel}>SEC</div>
																	<div className={styles.srsValue}>{item.section}</div>
																</div>
																<div className={styles.srsSet}>
																	<div className={styles.srsLabel}>ROW</div>
																	<div className={styles.srsValue}>{item.row}</div>
																</div>
																<div className={styles.srsSet}>
																	<div className={styles.srsLabel}>SEAT</div>
																	<div className={styles.srsValue}>{item.seat}</div>
																</div>
															</div>
															<SelectedPriceOptions selected={selected} seat_index={index} event_seat_uuid={item.event_seat_uuid} absorb_ticket_fees={absorb_ticket_fees} price_id={item.price_id} event_id={event_id} price_category_id={item.price_category_id} available_from={categories.find(c => c.price_category_id === item.price_category_id)?.available_from} currency={currency} update_price_id_on_selected={updatePriceIdOnSelected} tracking_pixels={tracking_pixels} companion_rules={companion_rules} />
															{item.accessible_seating === 1 ? (
																<div className={styles.ticketStubWarningsContainer}>
																	<div className={styles.ticketStubIndicator}>
																		<div className={styles.mapTooltipIndicator}>
																			<span className={styles.mapTooltipIndicatorIcon}>
																				<Accessible className={styles.seat_legend_accessible_icon} />
																				<svg viewBox="0 0 100 100" className={styles.iconADA}><g><circle cx="50" cy="50" r="50" style={{fill:"#000000"}}></circle></g></svg>
																			</span>
																			<span className={styles.mapTooltipIndicatorMessage}>
																				<span className={styles.iconBgAda}>Accessible Seating</span>
																			</span>
																		</div>
																	</div>
																</div>
															) : null}
															<button className={styles.ticketBagRemoveButton} onClick={e => removeSelectedTicket(index, item.event_seat_uuid)}><Close /></button>
															<ReservedSeatSummaryText event_id={event_id} price_category_id={item.price_category_id} />
														</div>
													</div>
												</li>
											))}
											{selected.length > 8 ? (
												<p className={styles.pdfWarning} style={{textAlign: "end", marginRight: "1px"}}>*more than 8 tickets cannot be sent as PDFs by email, but appear in your {org_title} account online or in the INTIX app</p>
											) : null}
										</ul>
										<div id="ticketBagTotal" className={styles.ticketBag}>
											{selected.length} Seat{selected.length > 1 ? ( <Fragment>s</Fragment> ) : null}
											<button className={styles.checkoutButton} onClick={e => submit_selected()} disabled={orphan_seat_warning != undefined}>Next</button>
										</div>
									</Fragment>
								) : null}
							</div>
						</div>
					) : display_ga_tooltip === false ? ( 
						<div className={styles.rwetwet}>
							<div className={styles.lhAZCq}>
								<select value={ticketsWanted} id="filter-bar-quantity" aria-label={"Quantity"} className={styles.haxjvV} onChange={e => setTicketsWanted(e.target.value)}>
									{Array.from({ length: event_ticket_limit }, (_, i) => i + 1).map((num) => (
										<option key={num} value={num}>
											{num} Ticket{num > 1 ? 's' : ''}
										</option>
									))}
								</select>
								<ExpandMore className={styles.kYdtvU} />
							</div>
							<div className={styles.iCrRBE}>
								<button className={styles.jMlrxd} onClick={e => setTabSelected(0)} style={tabSelected === 0 ? { borderBottom:"5px solid #" + orgBackgroundColor, color:"rgb(18, 18, 18)" } : { borderBottom:"5px solid #fff"}}>Lowest Price</button>
								<button className={styles.jMlrxd} onClick={e => setTabSelected(1)} style={tabSelected === 1 ? { borderBottom:"5px solid #" + orgBackgroundColor, color:"rgb(18, 18, 18)" } : { borderBottom:"5px solid #fff"}}>Best Seats</button>
							</div>
							{absorb_ticket_fees === 1 && absorb_transaction_fees === 1 ? ( <div className={styles.fbBUZH}>We’re All In: <span className={styles.hWZvOT}>Prices include fees.</span></div> ) : null}
							{tabSelected === 0 ? ( <LowestPrice absorb_ticket_fees={absorb_ticket_fees} absorb_transaction_fees={absorb_transaction_fees} set_hover_right_list={set_hover_right_list} org_background_color={orgBackgroundColor} currency={currency} on_section_click={on_section_click} map_sections={map_sections} tickets_available={tickets_available} tickets_wanted={ticketsWanted} categories={categories.filter((a,b) => a.membership_category_id === 0 )} seat_add_to_cart={seat_add_to_cart} /> ) : null}
							{tabSelected === 1 ? ( <BestSeats absorb_ticket_fees={absorb_ticket_fees} absorb_transaction_fees={absorb_transaction_fees} set_hover_right_list={set_hover_right_list} org_background_color={orgBackgroundColor} currency={currency} categories={categories.filter((a,b) => a.membership_category_id === 0 )} on_section_click={on_section_click} map_sections={map_sections} tickets_available={tickets_available} tickets_wanted={ticketsWanted} focal_point={focal_point} seat_add_to_cart={seat_add_to_cart} /> ) : null}
						</div>
					) : null}
				</Fragment>
			)}
		</Fragment>
	)
}

function LowestPrice({ absorb_ticket_fees, absorb_transaction_fees, set_hover_right_list, org_background_color, currency, on_section_click, map_sections, tickets_available, tickets_wanted, categories, seat_add_to_cart }){
	const sortedCategories = useMemo(() => {

		const groupedInventory = tickets_available.reduce((acc, tito) => {
            const key = `${tito.esid}-${tito.r}`;
            if (!acc[key]) acc[key] = [];
            acc[key].push(tito);
            return acc;
        }, {});

        const getValidRows = (sectionId, ticketsNeeded) => {
	        const sectionRows = Object.keys(groupedInventory).filter(key => key.startsWith(`${sectionId}-`));
	        const validRows = [];

	        for(const rowKey of sectionRows){
	            const rowSeats = [...groupedInventory[rowKey]].sort((a, b) => { return String(a.s).localeCompare(String(b.s), undefined, { numeric: true }); });
	            
	            let currentGroup = [];
	            let rowIsPossible = false;
	            let cheapestSeats = [];

	            for (let i = 0; i < rowSeats.length - 1; i++) {
					const currentSeat = rowSeats[i];

					if ((currentSeat.ess === 0 || currentSeat.ess === 5) && currentSeat.as !== 1){
						currentGroup.push({ id: currentSeat.id, uuid: currentSeat.uuid, sec: currentSeat.sec, r: currentSeat.r, s: currentSeat.s, pcid: currentSeat.pcid, as: currentSeat.as, rv: currentSeat.rv, esid: currentSeat.esid, x: currentSeat.x, y: currentSeat.y });

						if (currentGroup.length >= ticketsNeeded) {
							rowIsPossible = true;
							cheapestSeats = currentGroup.slice(0, ticketsNeeded); 
							break;
						}

						const nextSeat = rowSeats[i + 1];
						if (nextSeat) {
							const currentVal = parseInt(currentSeat.s, 10);
							const nextVal = parseInt(nextSeat.s, 10);
							
							if (!isNaN(currentVal) && !isNaN(nextVal) && nextVal !== currentVal + 1) {
								currentGroup = [];
							} else if (isNaN(currentVal) && String(nextSeat.s).charCodeAt(0) !== String(currentSeat.s).charCodeAt(0) + 1) {
								currentGroup = [];
							}
						}
					} else { 
						currentGroup = [];
					}
				}
				if (rowIsPossible){ validRows.push({ key: rowKey, seats: cheapestSeats }); }
			}
			return validRows;
		};

        const availableOptions = map_sections.reduce((acc, section) => {
	        if (section.section_type === 1) {
	            const validRowKeys = getValidRows(section.event_section_id, tickets_wanted);

	            const rowItems = validRowKeys.flatMap(row => {
	                const avgX = row.seats.reduce((sum, t) => sum + Number(t.x), 0) / row.seats.length;
	                const avgY = row.seats.reduce((sum, t) => sum + Number(t.y), 0) / row.seats.length;
	                const ticketsInRow = groupedInventory[row.key];
	                const uniquePriceIds = [...new Set(ticketsInRow.map(t => t.pcid))];
	                const matchingCats = categories.filter(cat => uniquePriceIds.includes(cat.price_category_id));
	                return categories.filter(cat => uniquePriceIds.includes(cat.price_category_id)).map(cat => ({ ...cat, display_label: section.display_label, event_section_id: section.event_section_id, row_label: ticketsInRow[0].r, membership_seat_section_id: section.membership_seat_section_id, section_type: 1, seats: row.seats, posX: avgX, posY: avgY }));
	            });
	            return [...acc, ...rowItems];
	        }

	        if (section.seats_available >= tickets_wanted) {
	            const ga_category = categories.find(cat => cat.price_category_id === section.price_category_id);
	            if(ga_category){ return [...acc, { ...ga_category, display_label: section.display_label, event_section_id: section.event_section_id, row_label: null, membership_seat_section_id: section.membership_seat_section_id, section_type: section.section_type, posX: section.centroid.x, posY: section.centroid.y }]; }
	        }

	        return acc;
	    }, []);

        return availableOptions.filter(c => c.password === 0 && c.prices?.length > 0).sort((a, b) => {
            const minA = Math.min(...a.prices.map(p => p.price));
            const minB = Math.min(...b.prices.map(p => p.price));
            return minA - minB;
        }).slice(0, 50);

	}, [map_sections, tickets_available, tickets_wanted]);

	return (
		<ul className={styles.ebAFaJ} style={absorb_ticket_fees === 1 && absorb_transaction_fees === 1 ? {maxHeight:"calc(100vh - 319px)"} : {maxHeight:"calc(100vh - 269px)"}}>
			{sortedCategories.length === 0 ? ( <li className={styles.noMatches}>No matches found. Please try changing your filters.</li> ) : null}
			{sortedCategories.map((a,b) => (
				<LowestPriceItem key={"list_price_category_" + b} item={a} index={b} set_hover_right_list={set_hover_right_list} org_background_color={org_background_color} currency={currency} absorb_ticket_fees={absorb_ticket_fees} on_section_click={on_section_click} map_sections={map_sections} tickets_available={tickets_available} tickets_wanted={tickets_wanted} seat_add_to_cart={seat_add_to_cart} />
			))}
		</ul>
	)
}

function BestSeats({ absorb_ticket_fees, absorb_transaction_fees, set_hover_right_list, org_background_color, currency, categories, map_sections, on_section_click, tickets_available, tickets_wanted, focal_point, seat_add_to_cart }){
	const sortedCategories = useMemo(() => {
		const [focalX, focalY] = (focal_point ?? "0,0").split(',').map(Number);

		const groupedInventory = tickets_available.reduce((acc, tito) => {
			const key = `${tito.esid}-${tito.r}`;
			if (!acc[key]) acc[key] = [];
			acc[key].push(tito);
			return acc;
		}, {});

		const getValidRows = (sectionId, ticketsNeeded) => {
			const sectionRows = Object.keys(groupedInventory).filter(key => key.startsWith(`${sectionId}-`));
			const validRows = [];

			for (const rowKey of sectionRows) {
				const rowSeats = [...groupedInventory[rowKey]].sort((a, b) => String(a.s).localeCompare(String(b.s), undefined, { numeric: true }) );

				let currentGroup = [];
				let rowIsPossible = false;
				let bestSeats = [];

				for (let i = 0; i < rowSeats.length; i++){
					const currentSeat = rowSeats[i];
					if ( (currentSeat.ess === 0 || currentSeat.ess === 5) && currentSeat.as !== 1 ){
						currentGroup.push({ id: currentSeat.id, uuid: currentSeat.uuid, sec: currentSeat.sec, r: currentSeat.r, s: currentSeat.s, pcid: currentSeat.pcid, as: currentSeat.as, rv: currentSeat.rv, esid: currentSeat.esid, x: currentSeat.x, y: currentSeat.y });

						if (currentGroup.length >= ticketsNeeded) {
							rowIsPossible = true;
							bestSeats = currentGroup.slice(0, ticketsNeeded); 
							break;
						}

						const nextSeat = rowSeats[i + 1];
						if (nextSeat) {
							const currentVal = parseInt(currentSeat.s, 10);
							const nextVal = parseInt(nextSeat.s, 10);
							
							if (!isNaN(currentVal) && !isNaN(nextVal) && nextVal !== currentVal + 1) {
								currentGroup = [];
							} else if (isNaN(currentVal) && String(nextSeat.s).charCodeAt(0) !== String(currentSeat.s).charCodeAt(0) + 1) {
								currentGroup = [];
							}
						}
					} else { 
						currentGroup = [];
					}
				}
				if (rowIsPossible){ validRows.push({ key: rowKey, seats: bestSeats }); }
			}
			return validRows;
		};

		const availableOptions = map_sections.reduce((acc, section) => {
			if (section.section_type === 1) {
				const validRowKeys = getValidRows(section.event_section_id, tickets_wanted);

				const rowItems = validRowKeys.flatMap(row => {
					const avgX = row.seats.reduce((sum, t) => sum + Number(t.x), 0) / row.seats.length;
					const avgY = row.seats.reduce((sum, t) => sum + Number(t.y), 0) / row.seats.length;
					const ticketsInRow = groupedInventory[row.key];
					const uniquePriceIds = [...new Set(ticketsInRow.map(t => t.pcid))];
					return categories.filter(cat => uniquePriceIds.includes(cat.price_category_id)).map(cat => ({ ...cat, display_label: section.display_label, row_label: ticketsInRow[0].r, section_type: 1, event_section_id: section.event_section_id, membership_seat_section_id: section.membership_seat_section_id, posX: avgX, posY: avgY, seats: row.seats }));
				});
				return [...acc, ...rowItems];
			}

			if (section.seats_available >= tickets_wanted) {
				const ga_category = categories.find(cat => cat.price_category_id === section.price_category_id);
				if (ga_category){ return [...acc, { ...ga_category, display_label: section.display_label, row_label: null, section_type: section.section_type, event_section_id: section.event_section_id, membership_seat_section_id: section.membership_seat_section_id, posX: section.centroid.x, posY: section.centroid.y }]; }
			}
			return acc;
		}, []);

		return availableOptions.filter(c => c.password === 0 && c.prices?.length > 0).sort((a, b) => {
			const distA = Math.sqrt(Math.pow(a.posX - focalX, 2) + Math.pow(a.posY - focalY, 2));
			const distB = Math.sqrt(Math.pow(b.posX - focalX, 2) + Math.pow(b.posY - focalY, 2));
			return distA - distB;
		}).slice(0, 50);

	}, [map_sections, tickets_available, tickets_wanted, focal_point]);

	return (
		<ul className={styles.ebAFaJ} style={absorb_ticket_fees === 1 && absorb_transaction_fees === 1 ? {maxHeight:"calc(100vh - 319px)"} : {maxHeight:"calc(100vh - 269px)"}}>
			{sortedCategories.length === 0 ? ( <li className={styles.noMatches}>No matches found. Please try changing your filters.</li> ) : null}
			{sortedCategories.map((a,b) => ( <BestSeatsItem key={"list_event_section_" + b} item={a} index={b} set_hover_right_list={set_hover_right_list} org_background_color={org_background_color} currency={currency} absorb_ticket_fees={absorb_ticket_fees} categories={categories} on_section_click={on_section_click} tickets_available={tickets_available} tickets_wanted={tickets_wanted} seat_add_to_cart={seat_add_to_cart} map_sections={map_sections} /> ))}
		</ul>
	)
}

function SelectedPriceOptions({ event_id, absorb_ticket_fees, event_seat_uuid, price_category_id, price_id, available_from, currency, update_price_id_on_selected, tracking_pixels, companion_rules, selected, seat_index }){
	const [loading, setLoading] = useState(true);
	const [prices, setPrices] = useState([]);
	const [displayDropDown, setDisplayDropDown] = useState(false);

	useEffect(() => { if(tracking_pixels.some(e => e.type === 'google_tag') || tracking_pixels.some(e => e.type === 'google_analytics')){ for(var i = 0; i < prices.length; i++){ gtag.event('view_item', {currency: currency, items: [{item_id: prices[i].price_id, item_name: prices[i].title, price: ( prices[i].total_cost / 100 ).toFixed(2), index: 0  }]}); } } }, [prices]);

	useEffect(() => { 
		setLoading(true);
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event_id + '/price_category/' + price_category_id + '/prices', { method: 'GET', headers: { "Content-Type": "application/json" } })
		.then(response => response.json())
		.then(data => { setPrices(data); })
		.catch(error => { console.log(error); })
		.finally(() => { setLoading(false); });
	}, [event_seat_uuid]);

	useEffect(() => { if (price_id === 0 && prices.length > 0) { newPriceId(prices[0].price_id); } }, [price_id, prices]);

	function newPriceId( new_price_id ){ update_price_id_on_selected( event_seat_uuid, new_price_id ); }

	const getRewardStatus = (optionPriceId) => {
		if (price_id === optionPriceId) return { disabled: false, message: "" };
		
		const rewardRule = companion_rules?.find(r => r.reward_price_id === optionPriceId);
		if(rewardRule){
			const cartCounts = selected.reduce((acc, seat) => {
				acc[seat.price_id] = (acc[seat.price_id] || 0) + 1;
				return acc;
			}, {});

			const timesTriggered = Math.min( ...rewardRule.requirements.map(req =>  Math.floor((cartCounts[req.trigger_price_id] || 0) / req.trigger_quantity) ) );
			const maxAllowed = timesTriggered * rewardRule.reward_quantity;
			const currentRewardCount = cartCounts[rewardRule.reward_price_id] || 0;

			if (maxAllowed === 0) return { disabled: true, message: getUnlockMessage(rewardRule, false) };
			if (currentRewardCount >= maxAllowed) return { disabled: true, message: "(Maximum claimed)" };
		}

		const simulatedCart = selected.map(seat => event_seat_uuid === seat.event_seat_uuid ? { ...seat, price_id: optionPriceId } : seat );

		const simulatedCounts = simulatedCart.reduce((acc, seat) => {
			acc[seat.price_id] = (acc[seat.price_id] || 0) + 1;
			return acc;
		}, {});

		const breakingRule = companion_rules?.find(rule => {
			const timesTriggered = Math.min( ...rule.requirements.map(req =>  Math.floor((simulatedCounts[req.trigger_price_id] || 0) / req.trigger_quantity) ) );
			const maxAllowed = timesTriggered * rule.reward_quantity;
			const currentRewardCount = simulatedCounts[rule.reward_price_id] || 0;
			return currentRewardCount > maxAllowed;
		});

		if (breakingRule){
			console.log(breakingRule);
		    return { disabled: true, message: getUnlockMessage(breakingRule, true) };
		}

		return { disabled: false, message: "" };
	};

	const getUnlockMessage = (ruleToParse, isSimulation = false) => {
		if (!ruleToParse || !prices) return "Requires qualifying tickets to unlock";

		const requirementStrings = ruleToParse.requirements.map(req => {
			const ticket = prices.find(p => p.price_id === req.trigger_price_id);
			const ticketName = ticket ? ticket.title : "qualifying tickets";
			return `${req.trigger_quantity} × ${ticketName}`;
		});

		return `Requires ${requirementStrings.join(' and ')} to ${isSimulation ? 'keep' : 'unlock'}`;
	};

	if( loading ){ return ( <div className={styles.ticketDescription}><img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/login-loading.svg" alt="Loading..." title="Loading..." width="30" /></div> ) }

	if( prices.length === 0 ){
		return (
			<div className={styles.ticketDescription}>
				<div className={styles.oiunas}>
					{available_from != null ? ( <ScheduleOutlined /> ) : ( <WarningOutlined /> )}
					<p>{available_from != null ? "Prices for this seat will be available from " + available_from : "There are currently no prices available for this seat."}</p>
				</div>
			</div>
		)
	}

	const openUpward = selected.length >= 3 && seat_index === selected.length - 1;

	return (
		<div className={styles.ticketDescription}>
			<div className={styles.ticketDropDownSelect}>
				<div className={styles.hgFaQk} onClick={e => setDisplayDropDown(!displayDropDown)}>
					<div className={styles.kcyKkt}>
						<label className={styles.hVZzFq} style={prices.length === 1 ? {border:"none"}: null}>
							<span className={styles.flgpfp}>Select Ticket Type</span>
							<div className={styles.cwBJcW}>
								<div className={styles.bN7yH4}>
									<span>{prices.filter( item => item.price_id === price_id ).map( filteredPrice => ( filteredPrice.title ))}</span>
									<span><CurrencySymbol currency={currency} />{prices.filter( item => item.price_id === price_id ).map( filteredPrice => ( <Fragment>{( filteredPrice.price / 100 ).toFixed(2)}</Fragment> ) )}</span>
								</div>
							</div>
							{prices.length > 1 ? ( <Fragment>{displayDropDown ? ( <KeyboardArrowUp /> ) : ( <KeyboardArrowDown /> )}</Fragment> ) : null}
						</label>
						{displayDropDown ? (
							<div className={openUpward ? `${styles.eoFHoK} ${styles.eoFHoKUp}` : styles.eoFHoK}>
								<div className={styles.emyquA}>
									{prices.map((item, index) => {
										const status = getRewardStatus(item.price_id);
										return (
											<span key={"prices_selected_" + index} role="option" className={styles.hvCOzb} onClick={e => { if (status.disabled) return; newPriceId(item.price_id); setDisplayDropDown(false); }} style={{ opacity: status.disabled ? 0.4 : 1, cursor: status.disabled ? 'not-allowed' : 'pointer' }}>
												<div className={styles.gEKrpm}>
													<div className={styles.hNCGnx}>
														{item.title}
														{status.disabled ? <span style={{marginLeft:"4px"}} className={styles.gaOfferDisclaimer}>{status.message}</span> : null}
													</div>
													<div className={styles.kcTgrS}><CurrencySymbol currency={currency} />{( item.price / 100 ).toFixed(2)}</div>
												</div>
											</span>
										)
									})}
								</div>
							</div>
						) : null}
					</div>
					{/*<span className={styles.ticketDescriptionLabel}><select value={price_id}>{prices.map((item, index) => ( <option key={item.price_id} value={item.price_id}>{item.title}</option> ))}</select></span>*/}
				</div>
			</div>
		</div>
	)
}

function GeneralAdmissionSelectTooltip({ event_id, currency, event_section_id, background_color, addToCartLoading, event_url_string, membership_url_string, purchase_timeout, window_width, ga_close, tracking_pixels, unlocked_array, companion_rules }){
	const [loading, setLoading] = useState(true);
	const [section, setSection] = useState({});
	const [loadingPrices, setLoadingPrices] = useState(true);
	const [prices, setPrices] = useState([]);
	const [availableFrom, setAvailableFrom] = useState(null);
	const [selected, setSelected] = useState([]);
	const [urlUnlockPromotion, setUrlUnlockPromotion] = useState(undefined);

	const router = useRouter();

	useEffect(() => { getSection(); getPrices(); }, [event_section_id]);
	useEffect(() => { if( router.query.promotion_code != undefined ){ setUrlUnlockPromotion( router.query.promotion_code ) }; }, [router.isReady]);
	useEffect(() => { if(tracking_pixels.some(e => e.type === 'google_tag') || tracking_pixels.some(e => e.type === 'google_analytics')){ for(var i = 0; i < prices.length; i++){ gtag.event('view_item', {item_id: prices[i].price_id, item_name: prices[i].title }); } } }, [prices]);

	function getSection(){
		setLoading(true);
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event_id + '/sections/' + event_section_id, { method: 'GET', headers: { 'Content-Type': 'application/json', Authorization: cookie.get("token") } })
		.then(response => response.json())
		.then(data => { setSection(data); })
		.catch(error => { console.log(error); setSection({}); })
		.finally(() => { setLoading(false); });
	}

	function getPrices(){
		setLoadingPrices(true);
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event_id + '/sections/' + event_section_id + '/prices', { method: 'GET', headers: { 'Content-Type': 'application/json', Authorization: cookie.get("token") } })
		.then(response => response.json())
		.then(data => { setPrices(data.data.filter(a => a.show_online === 1)); setAvailableFrom(data.available_from ?? null); })
		.catch(error => { console.log(error); setPrices([]); setAvailableFrom(null); })
		.finally(() => { setLoadingPrices(false); });
	}

	function addToSelected(price_id,price_category_id,units,tickets_included){
		const updatedSelectedArray = [...selected, {"price_id":price_id,"price_category_id":price_category_id,"units":units,"tickets_included":tickets_included}];
		setSelected(updatedSelectedArray);
	}

	function removeFromSelected(price_id,units){
		let array_copy = [...selected];
		let index = array_copy.findIndex(o => o.price_id === price_id);
		if( index !== -1 ){
			array_copy.splice(index, 1);
			const validatedCart = validateCartRules(array_copy);
			setSelected(validatedCart);
		}
	}

	function addGaToCart(){
		addToCartLoading();
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event_id + '/add_general_admission', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Hold-Token': getHoldToken() }, body: JSON.stringify({ selected_prices: selected, event_id: event_id, event_section_id: event_section_id, hold_token: parseInt( getHoldToken() ), timeout: purchase_timeout }) })
		.then(response => response.json())
		.then(data => { if(data.error){ toast.error(data.error.message, { autoClose: 10000 }); addToCartLoading(); } else { window.location.assign( '/checkout/?event_url=' + event_url_string + "&token=" + getHoldToken() + ( ( urlUnlockPromotion != undefined ) ? ( "&promotion_code=" + urlUnlockPromotion ) : '') ); } })
		.catch(error => { toast.error(error, { autoClose: 10000 }); addToCartLoading(); });
	}

	function validateCartRules(currentCart) {
		let validCart = [...currentCart];

		if (!companion_rules || companion_rules.length === 0) return validCart;

		companion_rules.forEach(rule => {
			const cartCounts = validCart.reduce((acc, ticket) => {
				const id = ticket.price_id;
				acc[id] = (acc[id] || 0) + (ticket.units || 1);
				return acc;
			}, {});

			const timesTriggered = Math.min( ...rule.requirements.map(req => Math.floor((cartCounts[req.trigger_price_id] || 0) / req.trigger_quantity) ) );
			const maxAllowed = timesTriggered * rule.reward_quantity;
			const currentRewardCount = cartCounts[rule.reward_price_id] || 0;

			if (currentRewardCount > maxAllowed){
				let excessToRemove = currentRewardCount - maxAllowed;
				for (let i = validCart.length - 1; i >= 0; i--) {
					if (validCart[i].price_id === rule.reward_price_id) {
						validCart.splice(i, 1);
						excessToRemove--;
						if (excessToRemove === 0) break; 
					}
				}
			}
		});

		return validCart;
	}

	return (
		<div className={styles.gaTicketStubContent} id={"general-admission-" + event_section_id}>
			{loading === true || loadingPrices === true ? (
				<div className={styles.seatInfoLoading}><img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/login-loading.svg" alt="Loading..." title="Loading..." className={styles.seatInfoLoadingImg} /></div>
			) : (
				<Fragment>
					<div className={styles.gaTooltipContent}>
						<div className={styles.gaTooltipSRS}>
							<div className={styles.gaSRSset}>
								<div className={styles.gaClose} onClick={e => ga_close(event_section_id)}>X</div>
								<div className={styles.gaSRSlabel}>Sec</div>
								<div className={styles.gaSRSvalue}>{section.label}</div>
								<TicketSummaryText event_id={event_id} price_category_id={section.price_category_id} full_description={undefined} />
							</div>
						</div>
					</div>
					{prices.some(a => ( a.membership_type_id > 0 )) === true ? (
						<div className={styles.gaTooltipSection}>
							<div className={styles.gaTooltipContent}>
								<div className={styles.gaSplitContent}>
									<div className={styles.gaSplitContentPrimary}></div>
									<div className={styles.gaSplitContentSecondary}><a href={"https://am.intix.com/" + membership_url_string + "/buy"} className={styles.gaAddButton} style={{backgroundColor:"#"+background_color,color:getContrast(background_color)}}>Buy</a></div>
								</div>
							</div>
						</div>
					) : (
						<div className={styles.gaTooltipSection}>
							{prices.length > 0 || unlocked_array.filter(a => a.price_category_id == section.price_category_id).length > 0 ? (
								<Fragment>
									<ul className={styles.gaTooltipDelimitedList}>
										{unlocked_array.filter(a => a.price_category_id == section.price_category_id).map((item, index) => ( <li key={"list_item_" + event_section_id + "_" + item.price_id} className={styles.gaTooltipDelimitedListItem}><GeneralTooltipPrice price_id={item.price_id} title={item.title} sold_out={item.sold_out} tickets_remaining={item.tickets_remaining} max_units={item.max_units} price={item.total_cost} total_price={item.total_cost} tickets_included={item.tickets_included} currency={currency} add_to_selected={e => addToSelected(item.price_id,item.price_category_id,1,item.tickets_included)} remove_from_selected={e => removeFromSelected(item.price_id,item.tickets_included)} background_color={background_color} companion_rules={companion_rules} selected={selected} prices={prices} /></li> ))}
										{prices.map((item, index) => ( <li key={"list_item_" + event_section_id + "_" + item.price_id} className={styles.gaTooltipDelimitedListItem}><GeneralTooltipPrice price_id={item.price_id} title={item.title} sold_out={item.sold_out} tickets_remaining={item.tickets_remaining} max_units={item.max_units} price={item.price} total_price={item.total_price} tickets_included={item.tickets_included} currency={currency} add_to_selected={e => addToSelected(item.price_id,item.price_category_id,1,item.tickets_included)} remove_from_selected={e => removeFromSelected(item.price_id,item.tickets_included)} background_color={background_color} companion_rules={companion_rules} selected={selected} prices={prices} /></li> ))}
									</ul>
									<div className={styles.gaTooltipContent}>
										<div className={styles.gaSplitContent}>
											<div className={styles.gaSplitContentPrimary}>{selected.length > 0 ? (<Fragment>{selected.reduce((prev,next) => prev + (next.units * next.tickets_included),0)} Ticket{selected.reduce((prev,next) => prev + (next.units * next.tickets_included),0) > 1 ? "s" : null}</Fragment>) : null}</div>
											<div className={styles.gaSplitContentSecondary}><button className={styles.gaAddButton} style={{backgroundColor:"#"+background_color,color:getContrast(background_color) }} disabled={selected.length === 0} onClick={e => addGaToCart()}>Add</button></div>
										</div>
									</div>
								</Fragment>
							) : (
								<div className={styles.tyqaup}>
									<div className={styles.oiunas}>
										{availableFrom != null ? ( <ScheduleOutlined /> ) : ( <WarningOutlined /> )}
										<p>{availableFrom != null ? "Prices for this section will be available from " + availableFrom : "There are currently no prices available on this section."}</p>
									</div>
								</div>
							)}
						</div>
					)}
				</Fragment>
			)}
		</div>
	)
} 

function TicketSummaryText({ event_id, price_category_id, full_description }){
	const [loading, setLoading] = useState(true);
	const [text, setText] = useState(undefined);
	const [readMore, setReadMore] = useState(false);
	const [fullDescription, setFullDescription] = useState(full_description);

	useEffect(() => { if( price_category_id != undefined ){ axios.get('https://d2jun3ty2bmcrf.cloudfront.net/event/' + event_id + '/price_category/' + price_category_id + '/description.txt').then(res => { setText(res.data); setLoading(false); }).catch((error) => { setLoading(false); setText(undefined); }); } }, [price_category_id]);

	if( loading ){ return ( <div className={styles.gaSRSga}><img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/login-loading.svg" alt="Loading..." title="Loading..." width={20} height={20} /></div> ) }
	if( text === undefined ){ return ( <div className={styles.gaSRSga}>This section is unreserved general admission</div> ) }

	return ( 
		<div className={styles.gaSRSga}>
			{text.length > 150 && readMore === false && fullDescription === undefined ? (
				<div className={styles.readMore}>
					<div dangerouslySetInnerHTML={{__html: text.substring(0,75) + "..."}}></div>
					<button id={"read_less_" + price_category_id} className={styles.readMoreToggle} onClick={e => setReadMore(true)}>Read More</button>
				</div>
			) : (
				<Fragment>
					<div className={styles.readMore} dangerouslySetInnerHTML={{__html: text}}></div>
					{text.length > 150 && fullDescription === undefined ? ( <button id={"read_less_" + price_category_id} className={styles.readMoreToggle} onClick={e => setReadMore(false)}>Read Less</button> ) : null}
				</Fragment>
			)}
		</div> 
	)
}

function ReservedSeatSummaryText({ event_id, price_category_id }){
	const [loading, setLoading] = useState(true);
	const [text, setText] = useState(undefined);
	const [readMore, setReadMore] = useState(false);

	useEffect(() => { 
		if( price_category_id != undefined ){
			axios.get('https://d2jun3ty2bmcrf.cloudfront.net/event/' + event_id + '/price_category/' + price_category_id + '/description.txt').then(res => { setText(res.data); setLoading(false); }).catch((error) => { setLoading(false); setText(undefined); }); 
		}
	}, [price_category_id]);

	if( loading ){ return ( <div className={styles.gaSRSga}><img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/login-loading.svg" alt="Loading..." title="Loading..." width={20} height={20} /></div> ) }
	if( text === undefined ){ return (<Fragment></Fragment> ) }

	return ( 
		<div className={styles.gaSRSga}>
			{text.length > 150 && readMore === false ? (
				<div className={styles.readMore}>
					<div dangerouslySetInnerHTML={{__html: text.substring(0,75) + "..."}}></div>
					<button id={"read_less_" + price_category_id} className={styles.readMoreToggle} onClick={e => setReadMore(true)}>Read More</button>
				</div>
			) : (
				<Fragment>
					<div className={styles.readMore} dangerouslySetInnerHTML={{__html: text}}></div>
					{text.length > 150 ? ( <button id={"read_less_" + price_category_id} className={styles.readMoreToggle} onClick={e => setReadMore(false)}>Read Less</button> ) : null}
				</Fragment>
			)}
		</div> 
	)
}

function GeneralTooltipPrice({ title, currency, sold_out, max_units, tickets_remaining, price, total_price, tickets_included, background_color, remove_from_selected, add_to_selected, price_id, companion_rules, selected, prices }){
	const [addToCart, setAddToCart] = useState(0);

	useEffect(() => {
		if (!selected) return;
		const actualCartCount = selected.reduce((total, ticket) => {
			if(ticket.price_id === price_id) { return total + (ticket.units || 1); }
			return total;
		}, 0);

		if(addToCart !== actualCartCount){ setAddToCart(actualCartCount); }
	}, [selected, price_id]);

	const rule = companion_rules?.find(r => r.reward_price_id === price_id);
	let maxAllowed = max_units;

	if(rule){
		const cartCounts = selected.reduce((acc, ticket) => {
			const id = ticket.price_id;
			acc[id] = (acc[id] || 0) + (ticket.units || 1);
			return acc;
		}, {});

		const timesTriggered = Math.min( ...rule.requirements.map(req =>  Math.floor((cartCounts[req.trigger_price_id] || 0) / req.trigger_quantity) ) );
		maxAllowed = timesTriggered * rule.reward_quantity;
	}

	const finalMaxAllowed = Math.min(maxAllowed, max_units, tickets_remaining);

	const getUnlockMessage = () => {
		if (!rule || !prices) return "Requires qualifying tickets to unlock";

		const requirementStrings = rule.requirements.map(req => {
			const ticket = prices.find(p => p.price_id === req.trigger_price_id);
			const ticketName = ticket ? ticket.title : "qualifying tickets";
			return `${req.trigger_quantity} × ${ticketName}`;
		});

		return `Requires ${requirementStrings.join(' and ')} to unlock`;
	};

	return (
		<div className={styles.gaSplitContent}>
			<div className={styles.gaSplitContentPrimary}>
				<div className={styles.gaTicketTypeDescription}>
					<span>{title}</span>
				</div>
				<div>
					<div>
						<div className={styles.gaOfferPrice}>
							{sold_out === 1 ? ( <Fragment>SOLD OUT</Fragment> ) : ( <Fragment><CurrencySymbol currency={currency} />{( ( price * tickets_included ) / 100 ).toFixed(2)} ea</Fragment> )}
							{/*<Link href={"/"}  target="_blank">+ Fees</Link>*/}
							{rule && maxAllowed === 0 ? (
								<div className={styles.gaOfferDisclaimer}>{getUnlockMessage()}</div>
							) : rule && addToCart >= finalMaxAllowed && finalMaxAllowed > 0 ? (
								<div className={styles.gaOfferDisclaimer}>Maximum tickets claimed</div>
							) : !rule && addToCart >= finalMaxAllowed && finalMaxAllowed > 0 ? (
								<div className={styles.gaOfferDisclaimer}>Maximum limit reached</div>
							) : null}
						</div>
					</div>
				</div>
			</div>
			<div className={styles.gaSplitContentSecondary}>
				{sold_out === 0 ? ( 
					<div className={styles.qtyPicker}>
						{addToCart > 0 ? ( <button className={styles.gaButtonDecrement} style={{backgroundColor:"#"+background_color,color:getContrast(background_color)}} onClick={e => { remove_from_selected(price_id); setAddToCart(addToCart - 1);}}><RemoveOutlined className={styles.gaQtyPickerMinus} style={{fill:getContrast(background_color)}} /></button> ) : null}
						<div className={styles.gaQtyPickerNumber}>{addToCart}</div>
						<button disabled={addToCart >= finalMaxAllowed} className={styles.gaButtonIncrement} style={{backgroundColor:"#"+background_color,color:getContrast(background_color)}} onClick={e => {add_to_selected(price_id); setAddToCart(addToCart + 1);}}><AddOutlined className={styles.gaQtyPickerPlus} style={{fill:getContrast(background_color)}} /></button>
					</div>
				) : null}
			</div>
		</div>
	)
}

function HomeGameCalendar({ event_id, org_id, background_color }){
	const [loading, setLoading] = useState(true);
	const [display, setDisplay] = useState(false);
	const [homeGameList, setHomeGameList] = useState([]);

	useEffect(() => { getHomeGames(); }, [display]);

	function getHomeGames(){
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/org/' + org_id + '/events', { method: 'GET', headers: { 'Content-Type': 'application/json', Authorization: cookie.get("token") } })
		.then(response => response.json())
		.then(data => { setHomeGameList(data); })
		.catch(error => { console.log(error); })
		.finally(() => { setLoading(false); });
	}

	return (
		<div className={styles.calendar}>
			{loading === false && homeGameList.filter(k => k.event_id != event_id).length > 0 ? (
				<div className={styles.calendarSkinny}>
					{display === false ? (
						<button className={styles.calendarSkinnyToggle} onClick={e => setDisplay(true)} style={{backgroundColor:"#"+background_color,color:getContrast(background_color)}}>
							<TodayOutlined className={styles.calendarToggleIcon} style={{fill:getContrast(background_color)}} />
							<span>More Dates</span>
							<KeyboardArrowRight className={styles.calendarToggleIcon} style={{fill:getContrast(background_color)}} />
						</button>
					) : (
						<Fragment>
							<button className={styles.calendarBack} onClick={e => setDisplay(false)} style={{backgroundColor:"#"+background_color,color:getContrast(background_color)}}><KeyboardArrowLeft className={styles.calendarIconClose} style={{fill:getContrast(background_color)}} /></button>
							<div className={styles.calendarWrapper}>
								<div className={styles.calendarListView}>
									<h2 className={styles.calendarTitle} style={{backgroundColor:"#"+background_color,color:getContrast(background_color)}}>Upcoming</h2>
									<ol className={styles.calendarEventList} style={{backgroundColor:"#"+background_color,color:getContrast(background_color)}}>
										{homeGameList.filter(i => i.event_id != event_id).map((j,index) => (
											<li className={styles.calendarEventListItem} key={"event_" + j.event_id}>
												<Link href={"/event/[id]"} as={`/event/${j.url_string}`} prefetch={false} className={styles.calendarEventListItemLink} target="_blank" style={{backgroundColor:"#"+background_color}}>
													<article className={styles.calendarEventListItemArticle} style={{color:getContrast(background_color)}}>
														<div className={styles.eventCardContent}>
															<div className={styles.eventCardDetail}>
																<span className={styles.eventCardComplexTitle}>{j.start_date} <OppositionTeamIcon event_id={j.event_id} /></span>
																<span className={styles.eventCardTime}>{j.start_time}</span>
															</div>
														</div>
													</article>
												</Link>
											</li>
										))}
									</ol>
								</div>
							</div>
						</Fragment>
					)}
				</div>
			) : null}
		</div>
	)
}

function Legend({ event_id, categories, loading_categories, ticket_resale }){
	const [displayLegend, setDisplayLegend] = useState(true);

	useEffect(() => { if(categories.length > 2){ setDisplayLegend(false); } }, [categories]);

	return (
		<div className={styles.seat_legend}>
			<button className={displayLegend === true ? styles.seat_legend_display_toggle + " " + styles.expand : styles.seat_legend_display_toggle} onClick={e => setDisplayLegend(!displayLegend)}>
				<span>Legend</span>
				<KeyboardArrowUp />
			</button>
			{ displayLegend === true ? (
				<ul className={styles.seat_legend_items}>
					<Fragment>
						{categories.filter(e => e.show_in_legend === 1 && e.membership_category_id === 0).map((category, index) => (
							<li className={styles.seat_legend_item} key={"category_" + index}>
								<div className={styles.seat_legend_item_info}>
									<div className={styles.seat_legend_item_icon}>
										{category.password === 1 ? ( <LockOutlined className={styles.seat_legend_lock_icon} /> ) : null}
										<svg viewBox="0 0 100 100"><g><circle cx="50" cy="50" r="50" style={{fill:"#"+ category.hex_color}}></circle></g></svg>
									</div>
									<span>{category.title}</span>
								</div>
							</li>
						))}
					</Fragment>
					<li className={styles.seat_legend_item}>
						<div className={styles.seat_legend_item_info}>
							<div className={styles.seat_legend_item_icon}>
								<Accessible className={styles.seat_legend_accessible_icon} />
								<svg viewBox="0 0 100 100"><g><circle cx="50" cy="50" r="50" style={{fill:"#000000"}}></circle></g></svg>
							</div>
							<span>Accessible Seating</span>
						</div>
					</li>
					{ticket_resale === 1 ? (
						<li className={styles.seat_legend_item}>
							<div className={styles.seat_legend_item_info}>
								<div className={styles.seat_legend_item_icon}>
									<Sync className={styles.seat_legend_sync_icon} />
									<svg viewBox="0 0 100 100"><g><circle cx="50" cy="50" r="50" style={{fill:"#2acaea"}}></circle></g></svg>
								</div>
								<Tooltip title="Upon choosing one of these seats, you will be redirected to the resale page">
									<span>Verified Resale</span>
								</Tooltip>
							</div>
						</li>
					) : null}
					<li className={styles.seat_legend_item}>
						<div className={styles.seat_legend_item_info}>
							<div className={styles.seat_legend_item_icon}><svg viewBox="0 0 100 100"><g><circle cx="50" cy="50" r="50" style={{fill:"#ebebeb"}}></circle></g></svg></div>
							<span>Unavailable</span>
						</div>
					</li>
				</ul>
			) : null}
		</div>
	)
}

function OppositionTeamIcon({ event_id }){
	const [loading, setLoading] = useState(true);
	const [opposition, setOpposition] = useState(undefined);
	const [oppositionImage, setOppositionImage] = useState(undefined);

	useEffect(() => { loadArtists(); }, []);

	function loadArtists(){
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event_id + '/artists', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
		.then(response => { if(response.ok){ return response.json(); } throw new Error('fetch error - /artists'); })
		.then(data => { if(data.error){ } else { if( data.length === 2 ){ setOpposition(data[1].title); setOppositionImage("https://d2jun3ty2bmcrf.cloudfront.net/artist/" + data[1].url_string + "/" + data[1].logo_image); } else { setOpposition(undefined); } } })
		.catch(error => { console.log(error); })
		.finally(() => { setLoading(false); })
	}

	return ( <Fragment>{loading === true ? ( <img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/imageInput-loading.svg" alt="loading" style={{height:"25px"}} /> ) : ( <Fragment>{opposition != undefined ? ( <Fragment> vs <span className={styles.teamIcon} style={{backgroundImage:"url('" + oppositionImage + "')"}}></span></Fragment> ) : null}</Fragment> )}</Fragment> )
}


export class ContactForm extends Component {
	constructor(props) {
		super(props);
		this.state = { contact_form_loading: true, contact_form_submitted: false, first_name: '', last_name: '', mobile_number: '', customer_email: '', comments: '', enquiry_type: '' };
 		this.updateMobileNumber = this.updateMobileNumber.bind(this);
	}

	componentDidMount(){
		axios.get(process.env.NEXT_PUBLIC_API_URL + '/public/me', { headers: { "Content-Type": "application/json", Authorization: cookie.get("token") } }).then(res => { if('user_id' in res.data){ this.setState({ contact_form_loading: false, first_name: res.data.first_name, last_name: res.data.last_name, customer_email: res.data.email_address }) } else { this.setState({ contact_form_loading: false }) } }, error => { this.setState({ contact_form_loading: false }) });
	}

	handleSubmit(){
		this.setState({ contact_form_loading: true }); 
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/contact', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ url_string: this.props.url_string, first_name: this.state.first_name, last_name: this.state.last_name, mobile_number: this.state.mobile_number, customer_email: this.state.customer_email, comments: this.state.comments, enquiry_type: this.state.enquiry_type }) })
		.then(response => { if(response.ok){ return response.json(); } throw new Error('fetch error - /contact'); })
		.then(data => { if(data.error){ } else { this.setState({ contact_form_submitted: true }); } })
		.catch(error => { console.log(error); })
		.finally(() => { this.setState({ contact_form_loading: false }); })
	}

	updateMobileNumber(value){ this.setState({ mobile_number: value }); }

	render(){
		return (
			<Fragment>
				{ this.state.contact_form_loading === true ? (
					<div className={styles.hTRmfd}><img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/login-loading.svg" alt="Loading" title="Loading" width="100" /></div>
				) : (
					<Fragment>
						{ this.state.contact_form_submitted === true ? (
							<div className={styles.confirmation}><p>Your enquiry has been submitted. Please allow 48-72 hours for a response.</p></div>
						) : (
							<form>
								<div className={styles.iBeRF}>
									<div className={styles.kRTYgI}>
										<label className={styles.hIxvWf}>Your Contact Request Reason</label>
										<select value={this.state.enquiry_type} className={styles.RjNYo} onChange={e => this.setState({enquiry_type:e.target.value})} required tabIndex="1">
											<option value={0}>Please Select</option>
											<option value={1}>Accessible Seating Request</option>
											<option value={5}>Ticket Enquiry</option>
											<option value={2}>Refund Request</option>
											<option value={3}>General Event Enquiry</option>
											<option value={4}>Other</option>
										</select>
									</div>
								</div>
								<div className={styles.iBeRF}>
									<div className={styles.kRTYgI}>
										<label className={styles.hIxvWf}>Your Email Address</label>
										<input type="email" value={this.state.customer_email} className={styles.TzSHd} onChange={e => { this.setState({customer_email:e.target.value})} } placeholder="john.citizen@example.com" required tabIndex="2" />
									</div>
								</div>
								<div className={styles.iBeRF}>
									<div className={styles.kRTYgI}>
										<label className={styles.hIxvWf}>Your Mobile Number</label>
										<PhoneInput updateMobileNumber={this.updateMobileNumber} height="36px" dial_code="61" tab_index="3" margin_bottom="0" />
									</div>
								</div>
								<div className={styles.iBeRF}>
									<div className={styles.flVKPr}>
										<div className={styles.kRTYgI}>
											<label className={styles.hIxvWf}>Your First Name</label>
											<input type="text" value={this.state.first_name} className={styles.TzSHd} onChange={e => this.setState({first_name:e.target.value})} placeholder="John" required tabIndex="4" />
										</div>
									</div>
									<div className={styles.flVKPr}>
										<div className={styles.kRTYgI}>
											<label className={styles.hIxvWf}>Your Last Name</label>
											<input type="text" value={this.state.last_name} className={styles.TzSHd} onChange={e => this.setState({last_name:e.target.value})} placeholder="Citizen" required tabIndex="5" />
										</div>
									</div>
								</div>
								<div className={styles.iBeRF}>
									<div className={styles.kRTYgI}>
										<label className={styles.hIxvWf}>Your Enquiry</label>
										<textarea rows="4" cols="50" value={this.state.comments} onChange={e => this.setState({comments:e.target.value})} className={styles.fRitLs} placeholder="What's your enquiry?" required tabIndex="6" />
									</div>
								</div>
								<div className={styles.submitDiv}>
									<button onClick={e => this.handleSubmit()} className={styles.submitButton} style={{color:this.props.color, backgroundColor: this.props.backgroundColor}} tabIndex="7" disabled={this.state.customer_email.length < 5 || parseInt(this.state.enquiry_type) === 0 || this.state.mobile_number.length < 2 || this.state.first_name.length < 2 || this.state.last_name.length === 0 || this.state.comments.length < 5}>Submit</button>
								</div>
							</form>
						)}
					</Fragment>
				)}
			</Fragment>
		)
	}
}

function LowestPriceItem({ item, index, set_hover_right_list, org_background_color, currency, on_section_click, map_sections, seat_add_to_cart }){
	const section = map_sections.find(s => s.event_section_id === item.event_section_id);
	if (!section || !item.prices || item.prices.length === 0) return null;

	const handleItemClick = () => {
		if( item.section_type === 0 || item.section_type === 2 ){ on_section_click( section.seats_available, section.event_section_id, section.membership_seat_section_id ); }
		if( item.section_type === 1 ){ item.seats.forEach(s => { seat_add_to_cart(s.uuid, s.sec, s.r, s.s, s.pcid, s.as, s.rv, s.esid); }); }
	};

	const restricted_view = item.seats?.some(s => s.rv === 1);

	return (
		<li key={"price_category_" + index} className={styles.xuzTQ} onMouseEnter={e => set_hover_right_list(item)} onMouseLeave={e => set_hover_right_list(undefined)} onClick={handleItemClick}>
			<div className={styles.jHFiiw}></div>
			<div className={styles.jzniRS}>
				<div className={styles.bKSNiv}>
					<div className={styles.cjXdmO}>
						<div className={styles.jHKkNl}>
							<div>
								<div className={styles.ihwBTg}>
									<span>Sec {section.display_label} { section.section_type === 1 ? ( <Fragment>• Row {item.row_label}</Fragment> ) : "• GA"}</span>
								</div>
								<div>
									<span>{item.prices[0].title}</span>
								</div>
							</div>
						</div>
						<div className={styles.doEwDl}>
							<div className={styles.bRAdqV}>
								<div className={styles.dasaGw}>
									<span className={styles.jgexCn} style={{color:"#"+org_background_color}}><CurrencySymbol currency={currency} />{( item.prices[0].price / 100 ).toFixed(2)}</span>
									<span>{restricted_view ? ( <Fragment><img style={{height:"18px",width:"18px"}} src="data:image/png;base64,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" /> Obstructed View</Fragment> ) : null}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</li>
	)
}

function BestSeatsItem({ item, index, set_hover_right_list, org_background_color, currency, on_section_click, tickets_wanted, seat_add_to_cart, map_sections }){
	const section = map_sections.find(s => s.event_section_id === item.event_section_id);
	if (!section || !item.prices || item.prices.length === 0) return null;

	const handleItemClick = () => {
		if( item.section_type === 0 || item.section_type === 2 ){ on_section_click( section.seats_available, section.event_section_id, section.membership_seat_section_id ); }
		if( item.section_type === 1 ){ item.seats.forEach(s => { seat_add_to_cart(s.uuid, s.sec, s.r, s.s, s.pcid, s.as, s.rv, s.esid); }); }
	};

	const restricted_view = item.seats?.some(s => s.rv === 1);

	return (
		<li key={"price_category_" + index} className={styles.xuzTQ} onMouseEnter={e => set_hover_right_list(item)} onMouseLeave={e => set_hover_right_list(undefined)} onClick={handleItemClick}>
			<div className={styles.jHFiiw}></div>
			<div className={styles.jzniRS}>
				<div className={styles.bKSNiv}>
					<div className={styles.cjXdmO}>
						<div className={styles.jHKkNl}>
							<div>
								<div className={styles.ihwBTg}>
									<span>Sec {item.display_label} { item.section_type === 1 ? ( <Fragment>• Row {item.row_label}</Fragment> ) : "• GA"}</span>
								</div>
								<div>
									<span>{item.prices[0].title}</span>
								</div>
							</div>
						</div>
						<div className={styles.doEwDl}>
							<div className={styles.bRAdqV}>
								<div className={styles.dasaGw}>
									<span className={styles.jgexCn} style={{color:"#"+org_background_color}}><CurrencySymbol currency={currency} />{( item.prices[0].price / 100 ).toFixed(2)}</span>
									<span className={styles.hJuAcy}>{restricted_view ? ( <Fragment><img style={{height:"18px",width:"18px"}} src="data:image/png;base64,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" /> Obstructed View</Fragment> ) : null}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</li>
	)
}

function PricesAvailableWarning({ selected, price_categories, org_background_color }){
	const optionLabelsSet = new Set();
	let seatsWithOptionsCount = 0;
	console.log(selected);

	selected.forEach(item => {
		const category = price_categories.find(pc => pc.price_category_id === item.price_category_id);
		if (category && Array.isArray(category.prices) && category.prices.length > 1){
			const unselectedPrices = category.prices.filter(p => p.price_id !== item.price_id);
            if (unselectedPrices.length > 0) {
	            seatsWithOptionsCount++;
				unselectedPrices.forEach(p => { if (p.title) optionLabelsSet.add(p.title); });
			}
		}
	});

	if (seatsWithOptionsCount === 0) return null;

	const optionLabels = Array.from(optionLabelsSet);
	const useGenericMessage = selected.length > 4 || optionLabels.length > 4;

	const formatList = (arr) => {
		if (arr.length === 1) return arr[0];
		if (arr.length === 2) return `${arr[0]} or ${arr[1]}`;
		return `${arr.slice(0, -1).join(", ")} or ${arr[arr.length - 1]}`;
	};

	return ( <div className={styles.priceOptionsNotice} style={{borderLeftColor:"#"+org_background_color}}>{useGenericMessage ? "Some of your seats have price options available — use the dropdown on each seat to choose." : `Looking for ${formatList(optionLabels)}? Use the dropdown on each seat to choose.`}</div> );
}
